export default {
  app: { name: "VowsEra.com", tagline: "Love. Planned Beautifully." },
  nav: {
    home: "Home", vendors: "Vendors", venues: "Venues", planningTools: "Planning Tools",
    about: "About", contact: "Contact", login: "Login", register: "Register",
    dashboard: "Dashboard", logout: "Logout",
    myWedding: "My Wedding", guestList: "Guest List", budget: "Budget",
    checklist: "Checklist", bookings: "Bookings", messages: "Messages",
    settings: "Settings", websiteBuilder: "Website Builder",
    vendorDashboard: "Dashboard", vendorProfile: "Business Profile",
    vendorBookings: "Bookings", vendorCalendar: "Availability",
    vendorMessages: "Messages", vendorSettings: "Settings",
    vendorPortfolio: "Portfolio", vendorAnalytics: "Analytics",
    vendorSubscriptionNav: "Subscription", vendorQuotes: "Quote Requests",
    vendorCrm: "Lead Pipeline", vendorPricing: "Dynamic Pricing",
    vendorTeam: "Team", vendorSubcontracts: "Subcontracts", vendorAds: "Ad Placements",
    groupBusiness: "Business", groupBookingsCalendar: "Bookings & Calendar",
    groupClientsLeads: "Clients & Leads", groupOperations: "Operations", groupSettings: "Settings",
    notifications: "Notifications", aiConcierge: "AI Concierge",
    ceremonyTemplates: "Ceremony Templates", rituals: "Rituals & Muhurat", baraatVidaai: "Baraat & Vidaai", weddingWeek: "Wedding Week", caricature: "Couple Caricature", qrInvites: "QR Invites",
    invitations: "Invitations", dayTimeline: "Day Timeline",
    budgetOptimizer: "Budget Optimizer", giftRegistry: "Gift Registry",
    vendorCalendarNav: "Vendor Calendar", photoWall: "Photo Wall",
    aiWriter: "AI Writer", seatingChart: "Seating Chart",
    analytics: "Analytics", afterWedding: "After Wedding", firstYear: "Your First Year", guestMessages: "Messages to Send", hospitalityDesk: "Hospitality Desk",
    timelineExport: "Timeline Export", planningBoards: "Planning Boards",
    vendorCompare: "Vendor Compare", pricing: "Pricing", adminPanel: "Admin Panel",
    // Couple sidebar labels (added 2026-05-09 — page content still uses
    // hardcoded strings; sidebar now fully translatable)
    weddingEvents: "Wedding Events", countdown: "Countdown",
    progressTracker: "Progress Tracker", rehearsal: "Rehearsal",
    sideManagement: "Side Management", rsvpAnalytics: "RSVP Analytics",
    familyPortal: "Family Portal", familyChat: "Family Chat",
    bookingsVendors: "Bookings & Vendors", vendorCheckIn: "Vendor Check-In",
    photoTags: "Photo Tags", moodBoard: "Mood Board",
    attirePlanner: "Attire Planner", speechesToasts: "Speeches & Toasts",
    currency: "Currency", liveFeed: "Live Feed",
    accommodations: "Accommodations", honeymoon: "Honeymoon",
    arrivalsPickups: "Arrivals & Pickups", giftsReceived: "Gifts Received", emergencyContacts: "Emergency Contacts",
    documentVault: "Document Vault", dataPrivacy: "Data & Privacy",
    smartAlerts: "Smart Alerts", destinationCalculator: "Destination Calculator",
    billingPlans: "Billing & Plans", affiliate: "Affiliate Program",
    groupPlanning: "Planning", groupGuests: "Guests",
    groupInvitations: "Invitations & Communication", groupVendors: "Vendors",
    groupDesignMedia: "Design & Media", groupTools: "Tools",
    groupDayOf: "Day-of & Beyond", groupDocuments: "Documents & Data",
    groupAccount: "Account"
  },
  common: {
    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", add: "Add",
    search: "Search", loading: "Loading...", noResults: "No results found",
    confirm: "Confirm", back: "Back", next: "Next", submit: "Submit", close: "Close",
    view: "View", create: "Create", update: "Update", details: "Details",
    status: "Status", actions: "Actions", all: "All", filter: "Filter", sort: "Sort",
    logout: "Logout", refreshPage: "Refresh Page", somethingWrong: "Something went wrong",
    yes: "Yes", no: "No", or: "or", of: "of",to: "to", from: "from", page: "Page",
    total: "Total", pending: "Pending", completed: "Completed", active: "Active",
    share: "Share", copy: "Copy", download: "Download", upload: "Upload", print: "Print",
    export: "Export", import: "Import", preview: "Preview", publish: "Publish",
    draft: "Draft", archived: "Archived", featured: "Featured",
    daysToGo: "days to go", today: "Today", yesterday: "Yesterday",
    guests: "guests", items: "items", photos: "photos", sent: "sent",
    // Tier 2 i18n migration additions
    requiredMarker: "*",
    errorTitle: "Error"
  },
  buttons: { learnMore: "Browse Vendors", getStarted: "Get Started", bookNow: "Book Now", viewDetails: "View Details", seeAll: "See All" },
  home: {
    // The hero — components/home/HeroShowcase. `preview` labels the drawn
    // dashboard beside the copy; the couple's name, date and place in it are
    // data, not text to translate.
    hero: {
      eyebrow: "All-in-one wedding platform",
      titleTop: "Your wedding.",
      titleAccent: "Beautifully planned.",
      lede: "Find the vendors worth booking, keep every detail and payment in one place, manage your guests, and build your own wedding website.",
      cta: "Start planning free",
      browseVendors: "Browse vendors",
      note: "Free to start. No card needed.",
      waitlist: {
        placeholder: "Enter your email address",
        submit: "Notify me at launch",
        note: "Be the first to know when VowsEra opens to couples.",
        joined: "You are on the list — we will email you the moment VowsEra opens.",
        failed: "That did not go through. Please try again."
      },
      highlights: {
        vendors: "Curated vendors", vendorsSub: "Photographers, venues, décor",
        ai: "AI-assisted planning", aiSub: "Plan smarter, stress less",
        guests: "Guest management", guestsSub: "RSVPs, seating, travel",
        website: "Your wedding website", websiteSub: "Share your story"
      },
      preview: {
        nav: {
          dashboard: "Dashboard", planning: "Planning", vendors: "Vendors", guests: "Guests",
          website: "Website", budget: "Budget", ai: "AI Assistant"
        },
        progress: "Planning progress",
        checklist: {
          venue: "Venue", photography: "Photography", catering: "Catering", invitations: "Invitations",
          booked: "Booked", inProgress: "In progress", notStarted: "Not started"
        },
        countdown: "Our wedding day",
        days: "days", hours: "hrs", minutes: "min",
        budget: "Budget",
        budgetOf: "of {{planned}} planned",
        guestList: "Guest list",
        guestsReplied: "have replied",
        ai: "VowsEra AI",
        aiSuggestion: "Three photographers match your style and budget in {{city}}."
      }
    },
    howItWorks: {
      badge: "SIMPLE & POWERFUL",
      title: "How VowsEra Works",
      subtitle: "From signup to celebration in 4 easy steps",
      step1: "Create Your Wedding", step1Desc: "Sign up free and set your wedding date, venue, and style in under 2 minutes.",
      step2: "Find & Book Vendors", step2Desc: "Browse verified vendors, compare quotes, check real-time availability, and book instantly.",
      step3: "Plan Every Detail", step3Desc: "Use AI-powered tools for budget, timeline, seating chart, guest list, and invitations.",
      step4: "Celebrate Your Day", step4Desc: "Go live with your timeline, photo wall, and let us handle the coordination."
    },
    premiumFeatures: {
      badge: "PREMIUM FEATURES",
      title: "Powerful Tools for Every Detail",
      subtitle: "AI-powered features that make wedding planning delightful"
    },
    testimonials: { badge: "LOVED BY 25,000+ COUPLES", title: "Real Couples, Real Stories" },
    cities: { title: "Plan Your Wedding Across the US & Mexico", subtitle: "Find top wedding vendors in your city" },
    pricing: { title: "Simple, Transparent Pricing", subtitle: "Start free. Upgrade when you need more." },
    features: {
      title: "Everything You Need to Plan Your Wedding",
      subtitle: "From finding vendors to managing your guest list, we've got you covered.",
      vendors: { title: "Find Trusted Vendors", desc: "Browse hundreds of verified wedding professionals — photographers, caterers, decorators and more." },
      website: { title: "Wedding Website", desc: "Create a beautiful wedding website to share your love story, event details, and collect RSVPs." },
      guests: { title: "Guest Management", desc: "Manage your guest list, track RSVPs, organize family groups, and plan seating arrangements." },
      budget: { title: "Budget Tracker", desc: "Stay on top of your wedding budget with category-wise tracking, vendor payments, and spending insights." }
    },
    categories: { title: "Browse by Category", subtitle: "Find the perfect professionals for every aspect of your wedding." },
    cta: { title: "Ready to Start Planning?", subtitle: "Join thousands of couples who planned their perfect wedding with VowsEra.com.", button: "Create Your Free Account" }
  },
  onboarding: {
    title: "Let's Plan Your Wedding",
    step1Title: "Who's getting married?",
    step1Desc: "Tell us about the happy couple",
    partnerName: "Your partner's first name",
    howWeMet: "How did you meet?",
    step2Title: "When and where?",
    step2Desc: "Don't worry if you haven't decided yet — you can update later",
    step3Title: "What's your style?",
    step3Desc: "This helps us recommend the right templates, vendors, and traditions",
    step4Title: "Budget & guest count",
    step4Desc: "Helps us optimize your planning and suggest the right vendors",
    step5Title: "You're all set!",
    step5Desc: "Here's a quick summary. You can always change these later.",
    startPlanning: "Start Planning!",
    culture: "Culture / Tradition",
    weddingType: "Wedding Type",
    currency: "Currency",
    budgetRange: "Budget range",
    estimatedGuests: "Estimated guests"
  },
  dashboardHome: {
    weddingOf: "WEDDING OF",
    daysToGo: "DAYS TO GO",
    todayTheDay: "Today's the day!",
    setDatePrompt: "Set your wedding date to see the countdown",
    planningProgress: "Planning Progress",
    nextSteps: "Next Steps",
    allCaughtUp: "You're on top of everything!",
    addGuests: "Add your first guests",
    browseVendors: "Browse and book vendors",
    setupChecklist: "Set up your checklist",
    setBudget: "Set your budget",
    createInvitation: "Create your invitation",
    startPhotoWall: "Start your photo wall"
  },
  invitations: {
    title: "Digital Invitation Builder",
    subtitle: "Create beautiful, culturally-themed digital invitations",
    templates: "Templates",
    myInvitations: "My Invitations",
    useTemplate: "Use This Template",
    editContent: "Content", editColors: "Colors", editFonts: "Fonts",
    publishInvite: "Publish", shareInvite: "Share",
    shareViaWhatsApp: "Share via WhatsApp",
    shareViaEmail: "Share via Email",
    copyLink: "Copy Link",
    viewStats: "View Stats",
    views: "Views", shares: "Shares"
  },
  timeline: {
    title: "Wedding Day Timeline",
    subtitle: "Minute-by-minute schedule for your big day",
    liveMode: "Live Mode",
    goLive: "Go Live",
    addItem: "Add Item",
    generateFromEvents: "Auto-Generate",
    start: "Start", done: "Done", delay: "Delay", skip: "Skip",
    vendorCheckIn: "Vendor Check In",
    export: "Export Timeline",
    fullSchedule: "Full Schedule",
    vendorView: "Vendors Only",
    familyView: "Family"
  },
  budgetOptimizer: {
    title: "Smart Budget Optimizer",
    subtitle: "AI-powered recommendations to optimize your wedding budget",
    totalBudget: "Total Budget",
    estimatedSpend: "Estimated Spend",
    paidSoFar: "Paid So Far",
    potentialSavings: "Potential Savings",
    recommendations: "Recommendations",
    allocations: "Allocations",
    regionalCompare: "Regional Compare",
    yourAllocation: "Your %",
    idealAllocation: "Ideal %"
  },
  giftRegistry: {
    title: "Gift Registry & Cash Gift Tracker",
    subtitle: "Track gifts, manage cash funds, and send thank-you notes",
    cashFunds: "Cash Funds",
    wishlist: "Wishlist",
    shagunTracker: "Gift Tracker",
    thankYouList: "Thank You List",
    addFund: "Add Fund", addItem: "Add Item", recordGift: "Record Gift",
    markThanked: "Mark Thanked",
    goalAmount: "Goal Amount", raisedAmount: "Raised",
    contributors: "contributors"
  },
  photoWall: {
    title: "Guest Photo & Video Wall",
    subtitle: "Shared gallery for your wedding memories",
    slideshow: "Slideshow", moderate: "Moderate",
    uploadPhoto: "Upload", allPhotos: "All",
    pendingModeration: "pending",
    approve: "Approve", reject: "Reject", approveAll: "Approve All"
  },
  seating: {
    title: "Seating Chart",
    subtitle: "Drag tables to arrange, click to assign guests",
    addTable: "Add Table",
    autoAssign: "Auto-Assign",
    tableName: "Table Name",
    capacity: "Capacity", shape: "Shape",
    round: "Round", rectangular: "Rectangular", square: "Square",
    long: "Long/Head", oval: "Oval",
    unassigned: "Unassigned Guests",
    assignTo: "Assign to...",
    seatedGuests: "Seated Guests"
  },
  analytics: {
    title: "Wedding Analytics",
    subtitle: "Real-time insights into your wedding planning progress",
    rsvpRate: "RSVP Rate",
    invitationViews: "Invitation Views",
    budgetUsed: "Budget Used",
    checklistDone: "Checklist Done",
    rsvpBreakdown: "RSVP Breakdown",
    guestGroups: "Guest Groups",
    mealPreferences: "Meal Preferences",
    allergies: "Allergies & Restrictions",
    budgetByCategory: "Budget by Category",
    paymentTimeline: "Payment Timeline",
    whoPaysWhat: "Who's Paying What",
    expenseSplitDetails: "Expense Split Details"
  },
  postWedding: {
    title: "After the Wedding",
    subtitle: "Thank-you cards, name change checklist, anniversary tracker",
    thankYouCards: "Thank You Cards",
    nameChange: "Name Change",
    countdownWidget: "Countdown Widget",
    generateMessage: "Generate",
    appliedToWebsite: "Applied!",
    nameChangeChecklist: "Name Change Checklist",
    anniversaryTracker: "Anniversary Tracker",
    nextAnniversary: "Next Anniversary",
    marriedFor: "Married For",
    embedCode: "Embed Code"
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark All Read",
    clearRead: "Clear Read",
    allCaughtUp: "You're all caught up!",
    noNotifications: "No notifications right now."
  },
  vendorCalendar: {
    title: "Vendor Availability",
    subtitle: "Check real-time availability, hold dates, and book vendors instantly",
    holdDate: "Hold This Date",
    releaseHold: "Release Hold",
    yourHolds: "Your Date Holds",
    hoursLeft: "hours left",
    available: "Available", booked: "Booked", blocked: "Blocked", tentative: "Tentative",
    peak: "Peak Season"
  },
  aiWriter: {
    title: "AI Website Content Writer",
    subtitle: "Generate beautiful, personalized content for every section of your wedding website",
    generateAll: "Generate All Sections",
    loveStory: "Our Love Story",
    heroSection: "Hero Section",
    eventDescriptions: "Event Descriptions",
    faqAnswers: "FAQ Answers",
    venueDescription: "Venue Description",
    travelTips: "Travel Tips",
    thankYouNote: "Thank You Note",
    howItWorks: "How it works",
    tellUsStory: "Tell Us About Your Story",
    apply: "Apply", applied: "Applied", generate: "Generate"
  },
  meals: {
    veg: "Vegetarian", nonVeg: "Non-Vegetarian", vegan: "Vegan",
    jain: "Jain", eggetarian: "Eggetarian", halal: "Halal",
    kosher: "Kosher", noPreference: "No Preference"
  },
  payers: {
    couple: "Couple", brideFamily: "Bride's Family",
    groomFamily: "Groom's Family", shared: "Shared", other: "Other"
  },
  cultures: {
    hindu: "Hindu", muslim: "Muslim", sikh: "Sikh", christian: "Christian",
    buddhist: "Buddhist", jain: "Jain", parsi: "Parsi", jewish: "Jewish",
    multicultural: "Multicultural / Fusion", other: "Other"
  },
  footer: {
    description: "Your complete wedding planning platform.",
    tagline: "Making wedding planning beautiful, organized, and stress-free.",
    quickLinks: "Quick Links", forVendors: "For Vendors", support: "Support", legal: "Legal",
    vendorSignup: "Become a Vendor", vendorLogin: "Vendor Login",
    helpCenter: "Help Center", faq: "FAQ", resources: "Resources",
    privacyPolicy: "Privacy Policy", termsOfService: "Terms of Service", popularCities: "Popular Wedding Cities", weddingsIn: "Weddings in {{city}}",
    copyright: "© {{year}} VowsEra.com. All rights reserved."
  },
  categories: {
    photography: "Photography", videography: "Videography", catering: "Catering",
    florists: "Florists", musicDjs: "Music & DJs", weddingPlanners: "Wedding Planners",
    makeupHair: "Makeup & Hair", cakesDesserts: "Cakes & Desserts",
    mehndiArtists: "Mehndi Artists", pandits: "Pandits & Priests", mandapDecor: "Mandap & Tent Decor",
    bridalWear: "Bridal Wear", baraatBands: "Baraat Band & Dhol"
  },
  auth: {
    loginTitle: "Welcome Back", loginSubtitle: "Sign in to your account",
    registerTitle: "Create Account", registerSubtitle: "Start planning your wedding",
    email: "Email Address", password: "Password", confirmPassword: "Confirm Password",
    firstName: "First Name", lastName: "Last Name", phone: "Phone Number",
    forgotPassword: "Forgot Password?", rememberMe: "Remember me", noAccount: "Don't have an account?",
    hasAccount: "Already have an account?", signUp: "Sign Up", signIn: "Sign In",
    accountType: "Account Type", couple: "Couple", vendor: "Vendor",
    forgotTitle: "Forgot Password",    resetTitle: "Reset Password", newPassword: "New Password", backToLogin: "Back to Login",
    emailPlaceholder: "Email address", passwordPlaceholder: "Password",
    confirmPlaceholder: "Confirm password", firstNamePlaceholder: "First name", lastNamePlaceholder: "Last name",
    invalidEmail: "Invalid email address", emailRequired: "Email is required",
    passwordRequired: "Password is required", passwordMin: "Minimum 8 characters",
    confirmRequired: "Please confirm password", passwordMismatch: "Passwords do not match",
    firstNameRequired: "First name is required",
    // Tier 2 Auth migration (2026-05-09)
    seoLogin:           "Login",
    seoRegister:        "Register",
    seoForgot:          "Forgot Password",
    seoReset:           "Reset Password",
    signingIn:          "Signing in...",
    creatingAccount:    "Creating account...",
    sendingReset:       "Sending...",
    resettingPassword:  "Resetting...",
    loginFailed:        "Login failed.",
    accountClaimed:     "Your account is ready. Sign in with your new password — we'll email you a code to confirm your address.",
    invalidCredentials: "Invalid email or password.",
    registerFailed:     "Registration failed.",
    forgotFailed:       "Failed to send reset link. Please try again.",
    resetFailed:        "Failed to reset password. Please try again.",
    forgotSubtitle:     "Enter your email and we'll send you reset instructions",
    forgotSentTitle:    "Check your inbox",
    forgotSentBody:     "If an account exists for that email, we've sent reset instructions.",
    resetSubtitle:      "Choose a new password for your account",
    resetSuccessTitle:  "Password reset!",
    resetSuccessBody:   "Your password has been changed. You can now sign in with your new password.",
    backToLoginLink:    "Back to login",
    confirmNewPassword: "Confirm Password",
    // Register: OTP verification step
    seoVerify:          "Verify Email",
    verifyTitle:        "Verify Your Email",
    otpSentTo:          "We've sent a 6-digit OTP to",
    otpInstructions:    "Enter the 6-digit verification code sent to your email. The OTP expires in 1 hour.",
    otpDigitsHint:      "Please enter all 6 digits",
    verifyContinue:     "Verify & Continue",
    didntReceive:       "Didn't receive the code?",
    resendIn:           "Resend in {{seconds}}s",
    resendOtp:          "Resend OTP",
    backToRegistration: "← Back to registration",
    enterOtp6:          "Please enter the 6-digit OTP",
    enterValidOtp:      "Please enter a valid OTP",
    verificationFailed: "Verification failed",
    resendFailed:       "Failed to resend OTP",
    venueOwner:         "Venue Owner",
    coordinator:        "Coordinator",
    // Forgot Password
    pleaseEnterEmail:   "Please enter your email.",
    somethingWentWrong: "Something went wrong.",
    pleaseEnterOtp:     "Please enter the 6-digit OTP.",
    passwordMinError:   "Password must be at least 8 characters.",
    passwordsNoMatch:   "Passwords do not match.",
    failedReset:        "Failed to reset password.",
    forgotIntro:        "Enter your email and we'll send you an OTP to reset your password.",
    forgotLinkIntro:    "Enter your email and we'll send you a link to reset your password.",
    sendResetLink:      "Send Reset Link",
    checkInboxTitle:    "Check your inbox",
    checkInboxBody:     "We've sent a password reset link to {{email}}. The link expires in 60 minutes.",
    checkInboxSpam:     "Don't see it? Check your spam folder, or try sending to a different email.",
    sendToDifferentEmail: "Use a different email",
    sending:            "Sending...",
    sendOtp:            "Send OTP",
    backToLoginArrow:   "← Back to Login",
    resetIntro:         "Enter the OTP sent to {{email}} and your new password.",
    otpCode:            "OTP Code",
    didntReceiveShort:  "Didn't receive?",
    resendInSeconds:    "Resend in {{seconds}}s",
    resetting:          "Resetting...",
    resetPasswordBtn:   "Reset Password",
    changeEmail:        "← Change email",
    passwordResetTitle: "Password Reset!",
    passwordResetBody:  "Your password has been reset successfully.",
    emailAddrLabel:     "Email Address",
    emailExamplePh:     "you@example.com",
    newPasswordLabel:   "New Password",
    confirmPasswordLabel: "Confirm Password",
  },
  settings: {
    title: "Settings", profileTab: "Profile", passwordTab: "Password", accountTab: "Account",
    firstName: "First Name", lastName: "Last Name", phone: "Phone",
    currentPassword: "Current Password", newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    changePassword: "Change Password", updateProfile: "Update Profile",
    personalInfo: "Personal Information", saveChanges: "Save Changes", dangerZone: "Danger Zone",
    language: "Language", selectLanguage: "Select Language"
  },
  register: {
    title: "Create Account", subtitle: "Start planning your wedding",
    firstName: "First Name", lastName: "Last Name", email: "Email Address",
    password: "Password", confirmPassword: "Confirm Password",
    accountType: "Account Type", couple: "Couple", vendor: "Vendor",
    hasAccount: "Already have an account?", signIn: "Sign In", signUp: "Sign Up"
  },
  dashboard: {
    title: "Dashboard", welcomeBack: "Welcome back", overview: "Overview",
    guestsCard: "Guests", budgetCard: "Budget", checklistCard: "Checklist", vendorsCard: "Vendors",
    attending: "Attending", pending: "Pending", declined: "Declined",
    used: "used", complete: "complete", confirmed: "Confirmed",
    rsvpOverview: "RSVP Overview", budgetOverview: "Budget Overview",
    upcomingTasks: "Upcoming Tasks", quickActions: "Quick Actions",
    totalBudget: "Total Budget", spent: "Spent", paid: "Paid", remaining: "Remaining",
    createWedding: "Create My Wedding", createWeddingDesc: "Set up your wedding details to get started",
    daysToGo: "days to go", married: "Married!", weddingDay: "It's your wedding day!"
  },
  myWedding: {
    title: "My Wedding", partnerFirst: "Partner's First Name", partnerLast: "Partner's Last Name",
    weddingDate: "Wedding Date", venue: "Venue", venueName: "Venue Name", venueCity: "Venue City",
    currency: "Currency", estimatedBudget: "Estimated Budget", estimatedGuests: "Estimated Guests",
    weddingTheme: "Wedding Theme", notes: "Notes", saveChanges: "Save Changes",
    createWedding: "Create Wedding", updateWedding: "Update Wedding"
  },
  guestList: {
    title: "Guest List", addGuest: "Add Guest", editGuest: "Edit Guest",
    firstName: "First Name", lastName: "Last Name", email: "Email", phone: "Phone",
    rsvpStatus: "RSVP Status", attending: "Attending", pending: "Pending", maybe: "Maybe",
    bride: "Bride", groom: "Groom", mutual: "Mutual",
    searchGuests: "Search guests...", noGuests: "No guests yet",
    totalGuests: "Total Guests", attendingCount: "Attending", pendingCount: "Pending",
    mealPreference: "Meal Preference", allergies: "Allergies",
    familyGroup: "Family Group", childGuest: "Child"
  },
  budget: {
    title: "Budget Tracker", addItem: "Add Item", editItem: "Edit Item",
    itemName: "Item Name", category: "Category", estimatedCost: "Estimated Cost",
    actualCost: "Actual Cost", paidAmount: "Paid Amount", isPaid: "Paid",
    totalEstimated: "Total Estimated", totalActual: "Total Actual",
    totalPaid: "Total Paid", remaining: "Remaining", overBudget: "Over Budget",
    noItems: "No budget items yet", addFirst: "Add your first budget item",
    paidBy: "Paid By"
  },
  checklist: {
    title: "Wedding Checklist", addTask: "Add Task", editTask: "Edit Task",
    taskName: "Task Name", dueDate: "Due Date", priority: "Priority",
    completed: "Completed", incomplete: "Incomplete",
    high: "High", medium: "Medium", low: "Low",
    noTasks: "No tasks yet", addFirst: "Add your first task"
  },
  msgPanel: {
    title: "Messages", conversations: "Conversations",
    noConversations: "No conversations yet",
    noConversationsDesc: "When you message a vendor, conversations will appear here.",
    selectConversation: "Select a conversation to start chatting",
    typePlaceholder: "Type a message..."
  },
  bookings: {
    title: "My Bookings", bookingNumber: "Booking #",
    package: "Package", eventDate: "Event Date", total: "Total",
    paid: "Paid", status: "Status", details: "Details",
    noBookings: "No bookings yet", noBookingsDesc: "Browse vendors and book services.",
    totalBookings: "Total Bookings", totalCost: "Total Cost",
    pending: "Pending", confirmed: "Confirmed", completed: "Completed", cancelled: "Cancelled",
    // Couple "Bookings & Vendors" combined page (Dashboard/MyBookings.jsx)
    seoTitle: "My Bookings & Vendors",
    pageTitle: "Bookings & Vendors",
    pageSubtitle: "Manage your vendor bookings and shortlist",
    tabVendors: "Shortlist & Quotes",
    weddingCancelledTitle: "This wedding has been cancelled.",
    weddingCancelledDesc: "The page is in read-only mode.",
    searchPlaceholder: "Search by booking # or package...",
    allStatuses: "All Statuses",
    emptyDesc: "Browse vendors and book services for your wedding.",
    vendorFallback: "Vendor",
    guestsCount: "{{count}} guests",
    paidLine: "Paid: {{amount}} ({{pct}}%)",
    markPaid: "Mark Paid",
    bookingCancelledNotice: "This booking has been cancelled. All fields are read-only.",
    vendorSection: "Vendor",
    bookingInfoSection: "Booking Info",
    packageLabel: "Package",
    guestCountLabel: "Guest Count",
    specialRequestsSection: "Special Requests",
    pricingSection: "Pricing",
    subtotal: "Subtotal",
    tax: "Tax",
    discount: "Discount",
    totalLabel: "Total",
    deposit: "Deposit",
    balanceDue: "Balance Due",
    paymentHistorySection: "Payment History",
    methodCol: "Method",
    transactionCol: "Transaction",
    noData: "No data",
    cancelBooking: "Cancel Booking",
    recordPayment: "Record Payment",
    bookingTotalLabel: "Booking total",
    alreadyPaidLabel: "Already paid",
    balanceDueLabel: "Balance due",
    paymentAmountLabel: "Payment amount",
    paymentAmountHelp: "Defaulted to the balance due. This amount will be deducted from your remaining wedding budget.",
    recording: "Recording...",
    confirmCancelLine: "Are you sure you want to cancel this booking with {{vendor}}?",
    confirmCancelNote: "The vendor will be notified by email. This action cannot be undone.",
    cancelReasonLabel: "Reason for cancellation (optional)",
    cancelReasonPlaceholder: "e.g. Change of plans, found another vendor...",
    keepBooking: "Keep Booking",
    cancelling: "Cancelling...",
    confirmCancelButton: "Yes, Cancel Booking",
    errors: {
      cancelFailed: "Failed to cancel booking.",
      loadFailed: "Failed to load bookings.",
      detailsFailed: "Failed to load booking details.",
      invalidAmount: "Enter a valid amount.",
      paymentFailed: "Failed to record payment."
    }
  },
  vendors: {
    title: "Wedding Vendors", subtitle: "Find trusted professionals for every aspect of your wedding",
    searchPlaceholder: "Search vendors, cities...",
    noVendors: "No vendors found", adjustFilters: "Try adjusting your filters.",
    verified: "Verified", featured: "Featured",
    topRated: "Top Rated", priceLowHigh: "Price: Low-High", priceHighLow: "Price: High-Low", byName: "Name",
    filterByCity: "Filter by city...", about: "About", packages: "Packages", gallery: "Gallery",
    reviews: "Reviews", quickInfo: "Quick Info", startingAt: "Starting at",
    priceRange: "Price Range", location: "Location", category: "Category",
    sendMessage: "Send Message", contactInfo: "Contact", services: "Services",
    compare: "Compare", shortlist: "Shortlist", requestQuote: "Request Quote", vendorsFound: "{{count}} vendors found",
    notFound: "Vendor not found", browseVendors: "Browse vendors",
    noPackages: "No packages listed.", noPhotos: "No photos yet.", noReviews: "No reviews yet.",
    conversationStarted: "Conversation started! Check your messages.",
    perEvent: "/event", includes: "Includes"
  },
  venues: {
    title: "Wedding Venues", subtitle: "Discover stunning venues for your perfect day",
    searchPlaceholder: "Search venues, cities...",
    noVenues: "No venues found", filterByCity: "Filter by city...",
    capacity: "Capacity", pricePerPlate: "Price/Plate", type: "Type", city: "City",
    amenities: "Amenities", about: "About", quickInfo: "Quick Info",
    estimatedCost: "Estimated Cost", addToWedding: "Add to My Wedding", venuesFound: "{{count}} venues found",
    notFound: "Venue not found", browseVenues: "Browse venues",
    guests: "guests", photos: "Photos", inquire: "Inquire"
  },
  planning: {
    title: "Planning Tools", subtitle: "Everything you need to plan your dream wedding, all in one place.",
    yourToolkit: "Your Planning Toolkit", timeline: "Wedding Planning Timeline",
    getStartedFree: "Get Started Free", readyToStart: "Ready to start planning?",
    createFreeAccount: "Create a free account to access all planning tools.",
    tools: {
      myWedding: "My Wedding", myWeddingDesc: "Set up your wedding details \u2014 date, venue, partner, budget, and more.",
      guestList: "Guest List", guestListDesc: "Manage guests, family groups, track RSVPs, and handle seating.",
      budget: "Budget Tracker", budgetDesc: "Track estimated costs, actual spending, and payments across all categories.",
      checklist: "Checklist", checklistDesc: "58+ default tasks across milestones \u2014 from 12 months out to wedding day.",
      website: "Wedding Website", websiteDesc: "Create a beautiful wedding website to share with your guests.",
      bookings: "Bookings", bookingsDesc: "View and manage all your vendor bookings and payment history.",
      messages: "Messages", messagesDesc: "Chat directly with your booked vendors and coordinate details.",
      settings: "Settings", settingsDesc: "Update your profile, change password, and manage account preferences."
    },
    phases: {
      p1: "12+ Months Before", p1i1: "Set your budget", p1i2: "Choose a wedding date", p1i3: "Book your venue", p1i4: "Start the guest list",
      p2: "9\u201312 Months", p2i1: "Book photographer & videographer", p2i2: "Choose your wedding party", p2i3: "Start dress shopping", p2i4: "Book caterer",
      p3: "6\u20139 Months", p3i1: "Send save-the-dates", p3i2: "Book DJ or band", p3i3: "Plan honeymoon", p3i4: "Choose d\u00E9cor theme",
      p4: "3\u20136 Months", p4i1: "Order invitations", p4i2: "Book florist", p4i3: "Plan welcome party", p4i4: "Finalize wedding attire",
      p5: "1\u20133 Months", p5i1: "Send invitations", p5i2: "Finalize menu", p5i3: "Arrange transport", p5i4: "Apply for marriage license",
      p6: "Final Weeks", p6i1: "Confirm all vendors", p6i2: "Create day-of timeline", p6i3: "Seating arrangements", p6i4: "Rehearsal dinner"
    }
  },
  pricing: {
    badge: "SIMPLE PRICING",
    heroTitle: "Plan Your Dream Wedding",
    heroSubtitle: "Start free with essential tools. Upgrade anytime to unlock AI features, unlimited guests, and premium planning tools.",
    monthly: "Monthly",
    yearly: "Yearly",
    savePercent: "Save {{percent}}%",
    // Sits under the hero in place of the old monthly/yearly toggle.
    monthlyOnlyNote: "Billed monthly. Upgrade any time, cancel any time — you keep your plan to the end of the month you've paid for.",
    free: "Free",
    perYear: "/year",
    perMonth: "/month",
    planFree: "Free",
    planSilver: "Silver",
    planGold: "Gold",
    planPlatinum: "Platinum",
    descFree: "Essential planning tools",
    descSilver: "Enhanced planning tools",
    descGold: "AI-powered planning",
    descPlatinum: "Complete wedding suite",
    mostPopular: "MOST POPULAR",
    startFree: "Start Free",
    getPlan: "Get {{plan}}",
    showComparison: "Show Full Feature Comparison",
    hideComparison: "Hide Full Feature Comparison",
    feature: "Feature",
    freeTrialNote: "7-day free trial",
    everythingInFree: "Everything in Free, plus:",
    everythingInSilver: "Everything in Silver, plus:",
    everythingInGold: "Everything in Gold, plus:",
    unlimited: "Unlimited",
    features: {
      weddingWebsite: "Wedding Website",
      guestManagement: "Guest Management",
      budgetTracker: "Budget Tracker",
      weddingChecklist: "Wedding Checklist",
      qrInvitations: "QR Code Invitations",
      aiConcierge: "AI Concierge",
      aiWriter: "AI Content Writer",
      budgetOptimizer: "Budget Optimizer",
      photoWall: "Photo Wall",
      giftRegistry: "Gift Registry",
      vendorCalendar: "Vendor Calendar",
      vendorCompare: "Vendor Comparison",
      seatingChart: "Seating Chart Builder",
      analytics: "Analytics Dashboard",
      liveTimeline: "Live Day Timeline",
      postWedding: "Post-Wedding Suite",
      customDomain: "Custom Domain",
      prioritySupport: "Priority Support"
    },
    preview: "Preview",
    guests20: "20 guests",
    guests50: "50 guests",
    guests500: "500 guests",
    items15: "15 items",
    items50: "50 items",
    items100: "100 items",
    designs1: "1 design",
    designs3: "3 designs",
    designs5: "5 designs",
    cardFeatures: {
      freeWebsite: "Wedding website",
      freeWebsitePreview: "Wedding website preview",
      freeGuests: "Up to 50 guests",
      freeGuests20: "Up to 20 guests",
      freeBudget: "15 budget items",
      freeChecklist: "Wedding checklist",
      freeQr: "1 QR invite design",
      freeCeremony: "Ceremony templates",
      silverWebsite: "Full wedding website",
      silverGuests: "Up to 50 guests",
      silverBudget: "50 budget items",
      silverDesigns: "3 invitation designs",
      silverVendorCalendar: "Vendor calendar",
      goldGuests: "Up to 500 guests",
      goldBudget: "100 budget items",
      goldAi: "AI Concierge & Writer",
      goldOptimizer: "Budget Optimizer",
      goldPhoto: "Photo Wall & Gift Registry",
      goldVendor: "Vendor Calendar & Compare",
      goldDesigns: "5 invitation designs",
      platUnlimited: "Unlimited everything",
      platSeating: "Seating chart builder",
      platAnalytics: "Analytics dashboard",
      platTimeline: "Live day timeline",
      platPostWedding: "Post-wedding suite",
      platDomain: "Custom domain",
      platSupport: "Priority support"
    },
    faq: {
      title: "Frequently Asked Questions",
      q1: "Can I try Gold features before buying?",
      a1: "Yes! Gold includes a 7-day free trial. No credit card required to start.",
      q2: "Can I change my plan later?",
      a2: "You can upgrade any time and it takes effect immediately — we credit the unused part of the month you've already paid for, so you only pay the difference. To move to a cheaper plan, cancel instead: you keep your current plan until the end of the month you've paid for, nothing renews, and you can pick a smaller plan after that. No long-term contracts either way.",
      q3: "What payment methods do you accept?",
      a3: "We accept all major credit cards, Apple Pay, and Google Pay via Stripe.",
      q4: "Is there a refund policy?",
      a4: "Yes — 30-day money-back guarantee on all paid plans. No questions asked.",
      q5: "Do vendor features cost extra?",
      a5: "Couple plans and vendor plans are separate. Vendors have their own tier pricing.",
      q6: "Can I share my plan with my partner?",
      a6: "Yes! Your partner can access the same wedding dashboard using the couple invite link."
    },
    ctaTitle: "Ready to Start Planning?",
    ctaSubtitle: "Join thousands of couples who planned their dream wedding with VowsEra.",
    ctaButton: "Get Started Free"
  },
  about: {
    title: "About VowsEra",
    heroTitle: "Love. Planned Beautifully.",
    heroSubtitle: "We\u2019re building the most comprehensive wedding planning platform, so you can focus on what matters most \u2014 celebrating your love.",
    missionTitle: "Our Mission",
    missionText: "VowsEra was created with a simple belief: every couple deserves a stress-free wedding planning experience. We combine powerful AI tools, real-time collaboration, and a curated vendor marketplace to make wedding planning joyful rather than overwhelming.",
    whyTitle: "Why Couples Choose VowsEra",
    why1Title: "All-in-One Platform",
    why1Desc: "From guest lists to budgets, vendor bookings to seating charts \u2014 manage everything in one place.",
    why2Title: "AI-Powered Tools",
    why2Desc: "Our AI concierge, content writer, and budget optimizer save you hours of planning time.",
    why3Title: "Real-Time Collaboration",
    why3Desc: "Plan together with your partner, coordinator, and family with live updates and shared dashboards.",
    why4Title: "Beautiful Wedding Websites",
    why4Desc: "Create a stunning wedding website with RSVP, gift registry, photo gallery, and travel info.",
    statsTitle: "VowsEra by the Numbers",
    statVendors: "Vendor Categories",
    statLanguages: "Languages Supported",
    statFeatures: "Planning Features",
    statCities: "Cities Covered",
    teamTitle: "Built with Love",
    teamText: "VowsEra is designed and developed by a passionate team dedicated to making every couple\u2019s wedding day perfect. We\u2019re continuously improving the platform based on feedback from real couples and vendors."
  },
  contact: {
    title: "Contact Us",
    heroTitle: "Get in Touch",
    heroSubtitle: "Have a question, suggestion, or need help? We\u2019d love to hear from you.",
    formName: "Your Name",
    formEmail: "Email Address",
    formSubject: "Subject",
    formMessage: "Your Message",
    formSubmit: "Send Message",
    formSuccess: "Thank you! Your message has been sent. We\u2019ll get back to you within 24 hours.",
    subjectOptions: {
      general: "General Inquiry",
      support: "Technical Support",
      billing: "Billing Question",
      vendor: "Vendor Partnership",
      feedback: "Feedback & Suggestions"
    },
    infoTitle: "Other Ways to Reach Us",
    emailLabel: "Email",
    emailValue: "support@vowsera.com",
    hoursLabel: "Business Hours",
    hoursValue: "Mon\u2013Fri, 9am\u20136pm EST",
    responseLabel: "Response Time",
    responseValue: "Within 24 hours"
  },
  notFound: {
    pageNotFound: "Page Not Found",
    thePageYoureLooking: "The page you're looking for doesn't exist or has been moved.",
    goHome: "Go Home",
  },
  ui: {
    save: "Save", saveChanges: "Save Changes", cancel: "Cancel", close: "Close", delete: "Delete", edit: "Edit", add: "Add",
    remove: "Remove", update: "Update", create: "Create", submit: "Submit", confirm: "Confirm",
    back: "Back", next: "Next", prev: "Previous", done: "Done", skip: "Skip", clear: "Clear",
    reset: "Reset", apply: "Apply", search: "Search", filter: "Filter", sort: "Sort",
    more: "More", less: "Less", view: "View", hide: "Hide", show: "Show", copy: "Copy",
    export: "Export", import: "Import", download: "Download", upload: "Upload", share: "Share",
    refresh: "Refresh", loading: "Loading...", saving: "Saving...", deleting: "Deleting...",
    noResults: "No results found", noData: "No data available",
    page: "Page", of: "of", showing: "Showing", to: "to", entries: "entries", total: "Total",
    all: "All", none: "None", yes: "Yes", no: "No", on: "On", off: "Off",
    name: "Name", email: "Email", phone: "Phone", address: "Address", city: "City",
    state: "State", country: "Country", date: "Date", time: "Time", status: "Status",
    type: "Type", category: "Category", description: "Description", notes: "Notes",
    amount: "Amount", price: "Price", quantity: "Quantity", actions: "Actions",
    firstName: "First Name", lastName: "Last Name", fullName: "Full Name",
    required: "Required", optional: "Optional", enabled: "Enabled", disabled: "Disabled",
    active: "Active", inactive: "Inactive", pending: "Pending", approved: "Approved",
    rejected: "Rejected", verified: "Verified", unverified: "Unverified",
    exportCsv: "Export CSV", importCsv: "Import CSV",
    addNew: "Add New", addItem: "Add Item", addGuest: "Add Guest", addFamily: "Add Family",
    editDetails: "Edit Details", viewDetails: "View Details", viewAll: "View All",
    confirmDelete: "Are you sure you want to delete this?",
    savedSuccessfully: "Saved successfully!", deletedSuccessfully: "Deleted successfully!",
    errorOccurred: "An error occurred. Please try again.",
    child: "Child", adult: "Adult", group: "Group", family: "Family",
    contact: "Contact", dietary: "Dietary", allergies: "Allergies",
    rsvp: "RSVP", attending: "Attending", notAttending: "Not Attending", maybe: "Maybe",
    allGroups: "All Groups", allFamilies: "All Families", allRsvp: "All RSVP",
    guests: "Guests", families: "Families", events: "Events", vendors: "Vendors", venues: "Venues",
    noFamiliesYet: "No family groups yet.", createFamilyGroup: "Create Family Group",
    paid: "Paid", unpaid: "Unpaid", partiallyPaid: "Partially Paid", planned: "Planned",
    overdue: "Overdue", dueDate: "Due Date", paidDate: "Paid Date",
    estimated: "Estimated", actual: "Actual", remaining: "Remaining", difference: "Difference",
    completed: "Completed", inProgress: "In Progress", notStarted: "Not Started",
    high: "High", medium: "Medium", low: "Low", priority: "Priority",
    today: "Today", tomorrow: "Tomorrow", thisWeek: "This Week", thisMonth: "This Month",
    overBudget: "Over Budget", underBudget: "Under Budget", onTrack: "On Track",
    photo: "Photo", photos: "Photos", video: "Video", videos: "Videos",
    title: "Title", subtitle: "Subtitle", label: "Label", value: "Value",
    select: "Select", selected: "Selected", deselect: "Deselect",
    approve: "Approve", reject: "Reject", flag: "Flag", archive: "Archive",
    preview: "Preview", publish: "Publish", draft: "Draft",
    monthly: "Monthly", yearly: "Yearly", weekly: "Weekly", daily: "Daily",
    startDate: "Start Date", endDate: "End Date", createdAt: "Created",
    updatedAt: "Updated", lastModified: "Last Modified",
    profile: "Profile", password: "Password", security: "Security", notifications: "Notifications",
    currentPassword: "Current Password", newPassword: "New Password", confirmPassword: "Confirm Password",
    changePassword: "Change Password", updateProfile: "Update Profile",
    language: "Language", theme: "Theme", timezone: "Timezone",
    personalInfo: "Personal Information", accountSettings: "Account Settings",
    weddingDetails: "Wedding Details", weddingDate: "Wedding Date",
    partnerName: "Partner Name", venueName: "Venue Name",
    budgetTotal: "Total Budget", guestCount: "Guest Count",
    noNotifications: "No notifications yet", markAllRead: "Mark All Read",
    bookingNumber: "Booking #", eventDate: "Event Date", packageName: "Package",
    vendorName: "Vendor", venuename: "Venue", totalCost: "Total Cost",
    noBookingsYet: "No bookings yet.", bookingConfirmed: "Booking Confirmed",
    bookingPending: "Pending", bookingCancelled: "Cancelled",
    taskName: "Task", milestone: "Milestone", assignedTo: "Assigned To",
    noTasksFound: "No tasks found.", addTask: "Add Task",
    photosUploaded: "Photos Uploaded", albumName: "Album Name",
    noPhotosYet: "No photos yet.", uploadPhotos: "Upload Photos",
    giftName: "Gift", registryUrl: "Registry URL", giftAmount: "Amount",
    noGiftsYet: "No gifts in registry yet.", addGift: "Add Gift",
    itemName: "Item Name", vendor: "Vendor", estimatedCost: "Estimated Cost",
    actualCost: "Actual Cost", paidAmount: "Paid Amount",
    addBudgetItem: "Add Budget Item", noBudgetItems: "No budget items yet."
  },

  // ── Migrated page-content keys (Tier 2 of i18n migration plan) ─────
  // Source-of-truth namespace for any page that has been moved off
  // hardcoded JSX literals onto t() calls. Convention: `<role>.<page>.<context>`.
  // See docs/i18n-migration-plan.md for the rules.
  publicPages: {
    vendorDetail: {
      seoSuffix:                "{{name}} — Wedding Vendor",
      verified:                 "Verified",
      featured:                 "Featured",
      reviewsCount:             "({{count}} reviews)",
      writeReview:              "Write a Review",
      writeReviewHeading:       "Write a Review",
      ratingLabel:              "Rating",
      ratingScale:              "{{n}}/5",
      commentLabel:             "Comment",
      commentPlaceholder:       "Share your experience...",
      submitting:               "Submitting...",
      submitReview:             "Submit Review",
      shortlisted:              "Shortlisted ✓",
      addToShortlist:           "Add to Shortlist",
      viewShortlistedVendors:   "View Shortlisted Vendors",
      msgIntro:                 "Hi! I'm interested in your services for my wedding.",
      priceLabels: {
        budget:                 "Budget",
        moderate:               "Moderate",
        premium:                "Premium",
        luxury:                 "Luxury",
      },
      reviewSuccess:            "Review submitted successfully!",
      reviewFailed:             "Failed to submit review",
      loginRequiredTitle:       "Login required",
      loginRequiredBody:        "Please log in to shortlist vendors.",
      removedTitle:             "Removed",
      removedBody:              "{{name}} removed from your shortlist.",
      shortlistedTitle:         "Shortlisted",
      shortlistedBody:          "{{name}} added to your shortlist.",
      shortlistFailedTitle:     "Shortlist failed",
      shortlistFailedBody:      "Could not update your shortlist. Please try again.",
      messageFailedTitle:       "Message failed",
      messageFailedBody:        "Could not start the conversation. Please try again.",
      errorTitle:               "Error",
    },
    venueDetail: {
      seoSuffix:                "{{name}} — Wedding Venue",
      capacityLabel:            "Capacity",
      pricePerPlateLabel:       "Price/Plate",
      featured:                 "⭐ Featured",
      reviewsCount:             "({{count}} reviews)",
      pin:                      "PIN",
      capacityCalc:             "{{capacity}} guests × {{price}}",
    },
    giftRegistry: {
      seoCoupleSuffix:          "{{couple}}'s Gift Registry",
      seoFallback:              "Gift Registry",
      heading:                  "Gift Registry",
      coupleHeadingSuffix:      "{{couple}}'s ",
      cashFundsTitle:           "Cash Funds",
      wishlistTitle:            "Wishlist",
      raisedOf:                 "{{raised}} of {{goal}}",
      sendVia:                  "Send via {{method}}",
      paymentLabelDefault:      "Payment",
      purchasedBadge:           "✓ Purchased",
      reservedBadge:            "Reserved",
      buyFallback:              "Buy",
      availableBadge:           "Available",
      emptyHint:                "The couple hasn't published any gift options yet.",
      errorTitle:               "Registry not found",
      errorBody:                "This link is invalid or has been disabled.",
      errorDefault:             "Gift registry not found or link has been disabled.",
      goHome:                   "Go home",
      footer:                   "Powered by VowsEra",
    },
    weddingSite: {
      seoSuffix:                "{{couple}}'s Wedding",
      seoFallback:              "Wedding Website",
      seoDescDefault:           "You're invited.",
      notFoundHeading:          "Wedding website not found",
      notFoundBody:             "This link is invalid or hasn't been published yet.",
      notFoundUnavailable:      "This wedding website is not available.",
      notFoundDefault:          "Wedding website not found or not yet published.",
      goHome:                   "Go home",
      rsvpNow:                  "RSVP Now",
    },
    photoWall: {
      coupleHeading:            "{{couple}}'s Photo Wall",
      fallbackHeading:          "Photo Wall",
      heroSubtitle:             "Share a moment from the wedding — your upload appears here once the couple approves it.",
      uploadHeading:            "Add a photo or video",
      photoVideoLabel:          "Photo or video",
      fileTypes:                "JPG, PNG, GIF, WEBP, HEIC, MP4, MOV, or WEBM up to {{mb}}MB.",
      yourNameLabel:            "Your name",
      captionLabel:             "Caption",
      optional:                 "Optional",
      uploading:                "Uploading…",
      uploadBtn:                "Upload",
      reviewNotice:             "Uploads are reviewed by the couple before appearing on this page.",
      noPhotosApproved:         "No photos have been approved yet — be the first to share!",
      tooLarge:                 "File is over {{mb}}MB. Pick a smaller one.",
      uploadSuccess:            "Thanks! Your upload is pending approval.",
      uploadFailed:             "Upload failed. Try again in a moment.",
      galleryNotFoundTitle:     "Gallery Not Found",
      galleryNotFoundBody:      "This photo wall link is invalid or has expired.",
      galleryNotFoundDefault:   "Gallery not found or link has expired.",
    },
  },

  couple: {
    seating: {
      gateTitle:                "Seating Chart",
      gateBlurb:                "Interactive drag-and-drop seating arrangement — available on Platinum plan.",
      gateFeat1:                "Drag-and-drop table builder",
      gateFeat2:                "Dietary & conflict detection",
      gateFeat3:                "Real-time collaboration",
      gateFeat4:                "Export to PDF or print",
      upgradeToPlatinum:        "Upgrade to Platinum",
      backToDashboard:          "Back to Dashboard",
      currentPlan:              "Current plan:",
      headerTitle:              "💺 Seating Chart",
      live:                     "● LIVE",
      headerHelp:               "Drag tables to arrange · Drag guests onto tables · Click table to manage guests",
      editorsOnline:            "👥 {{count}} editors online",
      autoAssign:               "✨ Auto-Assign ({{count}})",
      exportPdf:                "📄 Export PDF",
      addTable:                 "+ Add Table",
      stats: {
        tables:                 "Tables",
        seats:                  "Seats",
        seated:                 "Seated",
        unassigned:             "Unassigned",
      },
      floorPlanTitle:           "🎪 Wedding Floor Plan",
      conflictAlert:            "⚠️ Another editor is modifying this area",
      stage:                    "✦ STAGE / MANDAP ✦",
      noTablesEmpty1:           "Click",
      noTablesEmpty2:           "to start arranging your venue",
      hintDrag:                 "🖱 Drag tables to reposition",
      hintClick:                "👆 Click table to manage guests",
      hintGuestDrag:            "🎯 Drag guests from panel onto tables",
      panelUnassigned:          "Unassigned",
      panelTables:              "Tables",
      dragOntoCanvas:           "Drag onto canvas or use dropdown",
      seatPlaceholder:          "→ Seat",
      seatPrefix:               "Table:",
      noTablesYet:              "No tables yet. Click \"+ Add Table\" to get started.",
      full:                     "Full",
      leftSuffix:               "{{count}} left",
      conflictsTitle:           "⚠ Seating Conflicts Detected",
      conflictOverCap:          "is over capacity",
      seatedGuestsLabel:        "SEATED GUESTS",
      noGuestsSeated:           "No guests seated yet. Drag from sidebar or pick below.",
      seatLabel:                "Seat {{n}}",
      addFromUnassigned:        "ADD FROM UNASSIGNED",
      seatBtn:                  "+ Seat",
      removeBtn:                "Remove",
      addTableTitle:            "🪑 Add New Table",
      tableNameLabel:           "Table Name",
      tableNamePlaceholder:     "e.g. Head Table, Table 1",
      displayLabelLabel:        "Display Label",
      displayLabelPlaceholder:  "e.g. Bride's Family",
      shapeLabel:               "Shape",
      capacityLabel:            "Capacity",
      categoryLabel:            "Category",
      colorHint:                "Color (auto from category, or override)",
      adding:                   "Adding…",
      delTitle:                 "Delete Table",
      delMsg:                   "Are you sure you want to delete \"{{name}}\"? All assigned guests will be moved back to the unassigned list.",
      shapes: {
        round:                  "Round",
        rectangular:            "Rectangular",
        square:                 "Square",
        long:                   "Head Table",
        oval:                   "Oval",
      },
      tableFull:                "Table is full!",
      seatedAt:                 "{{name}} seated at {{table}}",
      tableAdded:               "Table added!",
      tableDeleted:             "Table deleted.",
      autoConfirm:              "Auto-assign all unassigned guests? Families will be grouped together.",
      autoComplete:             "Auto-assignment complete!",
      errors: {
        loadFailed:             "Failed to load seating data.",
        assignFailed:           "Failed to assign guest",
        addFailed:               "Failed to add table",
        deleteFailed:           "Failed to delete",
        removeFailed:           "Failed to remove",
        autoFailed:             "Auto-assign failed",
        exportFailed:           "Export failed",
        nameRequired:           "Table name is required",
      },
      pdf: {
        title:                  "Seating Chart — VowsEra",
        heading:                "💍 Wedding Seating Chart",
        statsLine:              "{{tables}} tables · {{seated}} seated · {{unassigned}} unassigned",
        colTable:               "Table",
        colShape:               "Shape",
        colSeats:               "Seats",
        colGuests:              "Guests",
      },
    },
    checklist: {
      seoTitle:                 "Checklist",
      pageTitle:                "Wedding Checklist",
      progressLine:             "{{done}}/{{total}} tasks done",
      overdueSuffix:            "({{count}} overdue)",
      generating:               "Generating...",
      generateDefault:          "Generate Default Checklist",
      generateEmptyBtn:         "✨ Generate Default Checklist",
      addTask:                  "Add Task",
      cancelledTitle:           "This wedding has been cancelled.",
      cancelledDesc:            "The page is in read-only mode.",
      noTasksYet:               "No tasks yet",
      emptyHint:                "Generate a default wedding checklist or add tasks manually.",
      addCustom:                "Add Custom Task",
      pctComplete:              "{{pct}}% Complete",
      ofTotal:                  "{{done}} of {{total}} tasks",
      weddingDateLine:          "Wedding date: {{date}}",
      filterAll:                "All",
      filterPending:            "Pending",
      filterCompleted:          "Done",
      clearFilters:             "Clear filters",
      addTaskTo:                "Add task to {{label}}",
      overdueBadge:             "Overdue",
      celebrationTitle:         "🎉 Checklist complete!",
      celebrationBody:          "Every planning task is done. Take a breath — you are ready.",
      addTitle:                 "Add Task",
      editTitle:                "Edit Task",
      titleLabel:               "Title",
      titlePlaceholder:         "e.g. Book photographer",
      categoryLabel:            "Category",
      selectCategory:           "Select Category",
      milestoneLabel:           "Milestone",
      milestones: {
        custom:                 "Custom",
        twelveMonths:           "12 Months Before",
        nineMonths:             "9 Months Before",
        sixMonths:              "6 Months Before",
        threeMonths:            "3 Months Before",
        oneMonth:               "1 Month Before",
        twoWeeks:               "2 Weeks Before",
        oneWeek:                "1 Week Before",
        dayOf:                  "Wedding Day",
        afterWedding:           "After Wedding",
      },
      priorityLabel:            "Priority",
      assigneeLabel:            "Assignee",
      assigneeOptions: {
        both:                   "Both",
        bride:                  "Bride",
        groom:                  "Groom",
        planner:                "Planner",
        family:                 "Family",
      },
      dueDateLabel:             "Due Date",
      descriptionLabel:         "Description",
      descriptionPlaceholder:   "Optional description",
      notesLabel:               "Notes",
      notesPlaceholder:         "Any notes...",
      saveChanges:              "Save Changes",
      addTaskBtn:               "Add Task",
      generatePromptTitle:      "Generate Default Checklist",
      generatePromptBody:       "This will add ~40 tasks organized by timeline milestones to help you plan your wedding.",
      okBtn:                    "OK",
      delTitle:                 "Remove Task",
      delMsg:                   "Are you sure you want to remove \"{{name}}\" from your checklist?",
      priorityLabels: {
        high:                   "High",
        medium:                 "Medium",
        low:                    "Low",
      },
      toasts: {
        taskUpdated:            "Task updated.",
        taskAdded:              "Task added.",
        taskRemoved:            "Task removed.",
        defaultGenerated:       "Default checklist generated successfully!",
      },
      errors: {
        loadFailed:             "Failed to load checklist.",
        updateFailed:           "Failed to update task.",
        saveFailed:             "Failed to save.",
        removeFailed:           "Failed to remove.",
        generateFailed:         "Failed to generate.",
      },
      validation: {
        titleRequired:          "Title is required.",
      },
    },
    timeline: {
      headerTitle:              "Wedding Day Timeline",
      live:                     "LIVE",
      goLive:                   "Go Live",
      export:                   "Export",
      autoGen:                  "Auto-Generate",
      autoGenLoading:           "...",
      addBtn:                   "Add",
      addManually:              "Add Manually",
      cancelledTitle:           "This wedding has been cancelled.",
      cancelledDesc:            "The page is in read-only mode.",
      stats: {
        total:                  "Total",
        completed:              "Completed",
        inProgress:             "In Progress",
        delayedSkipped:         "Delayed / Skipped",
        vendorCheckIns:         "Vendor Check-ins",
        dayCompletion:          "Day Completion",
      },
      day:                      "Day",
      dayN:                     "Day {{n}}",
      itemsCount:               "{{count}} items",
      allDays:                  "All Days",
      delayedSuffix:            "DELAYED {{minutes}}",
      checkedIn:                "Checked In",
      checkInRequired:          "Check-in Required",
      start:                    "▶ Start",
      done:                     "✅ Done",
      delay:                    "⚠ Delay",
      checkIn:                  "Check In",
      autoGenerated:            "Auto-generated from Events",
      editTitle:                "✏️ Edit Timeline Item",
      addTitle:                 "➕ Add Timeline Item",
      titleLabel:               "Title",
      titlePlaceholder:         "e.g. Bridal Makeup",
      dateLabel:                "Date",
      startLabel:               "Start",
      endLabel:                 "End",
      vendorCheckInSwitch:      "Vendor check-in required",
      saving:                   "Saving...",
      adding:                   "Adding...",
      saveChanges:              "Save Changes",
      addItem:                  "Add Item",
      exportTitle:              "Export Timeline",
      formatLabel:              "Format",
      viewLabel:                "View",
      formats: {
        text:                   "Text (.txt)",
        json:                   "JSON (.json)",
        pdf:                    "PDF (.pdf)",
      },
      views: {
        full:                   "Full",
        vendor:                 "Vendor",
        family:                 "Family",
      },
      exporting:                "Exporting...",
      download:                 "Download",
      shareTitle:               "📤 Share Timeline",
      familyBtn:                "👨‍👩‍👧 Family",
      vendorBtn:                "💼 Vendor",
      familyLabel:              "Family View",
      vendorLabel:              "Vendor Schedule",
      viewsCount:               "{{count}} views",
      noShareLinks:             "No share links yet.",
      delTitle:                 "Remove Timeline Item",
      delMsg:                   "Are you sure you want to remove this item from your timeline? This action cannot be undone.",
      validation: {
        titleRequired:          "Title is required.",
        dateRequired:           "Date is required.",
        startRequired:          "Start time is required.",
      },
      toasts: {
        addFailedTitle:         "Add Failed",
        addFailed:              "Failed to add timeline item",
        removedTitle:           "Removed",
        itemRemoved:            "Timeline item removed successfully.",
        errorTitle:             "Error",
        removeFailed:           "Failed to remove item.",
        generated:              "Generated",
        generatedDefault:       "Timeline generated!",
        generationFailedTitle:  "Generation Failed",
        generationFailed:       "Failed",
        exportFailedTitle:      "Export Failed",
        exportFailed:           "Failed to export timeline",
        linkCopied:             "Link Copied",
        existingCopied:         "Existing share link copied to clipboard.",
        linkCreated:            "Link Created",
        copiedShare:            "Share link copied to clipboard.",
        shareFailedTitle:       "Share Failed",
        shareFailed:            "Failed to create share link",
        copied:                 "Copied",
        copiedBody:             "Link copied to clipboard",
      },
      gateTitle:                "Day Timeline",
      gateDescription:          "Run your wedding day on a minute-by-minute schedule everyone can follow — vendors, family, and the couple.",
      gateB1:                   "Minute-by-minute run-of-show with start/end times per ceremony",
      gateB2:                   "Auto-progressing live view: upcoming → in-progress → completed",
      gateB3:                   "Share a public link with the wedding party so everyone is on the same page",
      gateB4:                   "Vendor check-in tracking and skip handling for off-script moments",
      // Print template (PDF export)
      printTitle:               "Wedding Timeline - {{role}}",
      printHeading:             "Wedding Day Timeline ({{role}})",
      printNoData:              "No timeline data found for this view.",
      printFooter:              "Generated by VowsEra - Your Personal Wedding Assistant",
    },
    myWedding: {
      seoTitle:                 "My Wedding",
      emptyHeading:             "Let's set up your wedding!",
      emptyBlurb:               "Add your wedding details to get started with planning.",
      createMyWedding:          "Create My Wedding",
      cancelledTitle:           "This wedding has been cancelled.",
      cancelledDesc:            "The page is in read-only mode. Your vendors have been notified.",
      venueTBD:                 "Venue TBD",
      daysToGo:                 "days to go",
      todayHero:                "Today! 🎉",
      married:                  "Married! 💕",
      daysAgo:                  "{{count}} days ago",
      setDateHint:              "Set a date to see countdown",
      editDetails:              "Edit Details",
      stat: {
        guests:                 "Guests",
        budget:                 "Budget",
        checklist:              "Checklist",
        vendorBookings:         "Vendor Bookings",
      },
      tasksFraction:            "{{done}}/{{total}} tasks",
      expensesCount:            "{{count}} expenses",
      confirmedCount:           "{{count}} confirmed",
      detailsTitle:             "Wedding Details",
      coupleLabel:              "Couple",
      dateLabel:                "Date",
      venueLabel:               "Venue",
      cityLabel:                "City",
      expectedGuests:           "Expected Guests",
      budgetLabel:              "Budget",
      statusLabel:              "Status",
      notSet:                   "Not set",
      links: {
        manageGuests:           "Manage Guest List",
        guestsDesc:             "{{guests}} guests, {{families}} families",
        budgetPlanner:          "Budget Planner",
        budgetDesc:             "{{count}} expenses tracked",
        checklistTitle:         "Wedding Checklist",
        checklistDesc:          "{{pct}}% complete",
        websiteTitle:           "Wedding Website",
        websitePublished:       "Published: {{subdomain}}",
        websiteNotPublished:    "Not published yet",
      },
      quickActionsTitle:        "Quick Actions",
      events:                   "Events",
      familyGroups:             "Family Groups",
      confirmedVendors:         "Confirmed Vendors",
      pendingRsvps:             "Pending RSVPs",
      // Modals
      createTitle:              "🎉 Create Your Wedding",
      editTitle:                "Edit Wedding Details",
      createIntro:              "Tell us about your special day:",
      editIntro:                "Update your wedding information:",
      partnerFirstNameLabel:    "Partner's First Name",
      partnerFirstNamePlaceholder: "Their first name",
      partnerLastNameLabel:     "Partner's Last Name",
      partnerLastNamePlaceholder: "Their last name",
      venuePlaceholder:         "e.g. Grand Resort Cancún",
      estimatedGuestsLabel:     "Estimated Guests",
      estimatedGuestsPlaceholder: "150",
      budgetPlaceholder:        "50000",
      createWedding:            "Create Wedding 🎉",
      saveChanges:              "Save Changes",
      statusOptions: {
        planning:               "Planning",
        confirmed:              "Confirmed",
        completed:              "Completed",
        cancelled:              "Cancelled",
      },
      cancelConfirm:            "Are you sure you want to cancel your wedding?\n\nThis will:\n• Set the wedding to read-only mode\n• Cancel all active vendor bookings\n• Notify all booked vendors via email\n\nThis action cannot be easily undone.",
      validation: {
        partnerFirstNameRequired: "Partner's first name is required.",
        weddingDateRequired:    "Wedding date is required.",
        weddingDateInvalid:     "Please enter a valid wedding date.",
        stateRequired:          "State is required. Please select a state.",
        cityRequired:           "City is required. Please select a city.",
      },
      toasts: {
        created:                "Wedding created! 🎉",
        updated:                "Wedding details updated.",
        cancelled:              "Wedding cancelled. Your vendors have been notified.",
      },
      errors: {
        loadFailed:             "Failed to load wedding data.",
        saveFailed:             "Failed to save.",
      },
    },
    home: {
      seoTitle:                 "Dashboard",
      welcomeNoWedding:         "Welcome, {{name}}!",
      letsSetup:                "Let's set up your wedding to get started.",
      createMyWedding:          "Create My Wedding",
      welcomeBack:              "Welcome back, {{name}}! 💍",
      yourWedding:              "Your wedding",
      venueTBD:                 "Venue TBD",
      daysToGo:                 "days to go",
      todayHero:                "Today! 🎉",
      married:                  "Married! 💕",
      daysAgo:                  "{{count}} days ago",
      setDate:                  "Set a date →",
      stat: {
        guests:                 "Guests",
        budget:                 "Budget",
        checklist:              "Checklist",
        vendors:                "Vendors",
      },
      yesShort:                 "{{count}} yes",
      pendingShort:             "{{count}} pending",
      noShort:                  "{{count}} no",
      tasksDone:                "{{done}}/{{total}} tasks done",
      confirmedCount:           "{{count}} confirmed",
      rsvpStatusTitle:          "RSVP Status",
      guestsLabel:              "guests",
      attending:                "Attending ({{count}})",
      pending:                  "Pending ({{count}})",
      declined:                 "Declined ({{count}})",
      totalBudget:              "Total Budget",
      totalActual:              "Total Actual",
      overBudget:               "Over Budget",
      remaining:                "Remaining",
      expensesCount:            "{{count}} expenses",
      usedPct:                  "{{pct}}% used",
      websiteTitle:             "Wedding Website",
      published:                "Published",
      draft:                    "Draft",
      defaultTpl:               "default template",
      tplSuffix:                "{{tpl}} template",
      edit:                     "Edit",
      view:                     "View",
      websiteHint:              "Create a beautiful wedding website for your guests.",
      createWebsite:            "Create Website",
      viewAll:                  "View All →",
      noTasksYet:               "No tasks yet. Generate a checklist!",
      allCaughtUp:              "All caught up! 🎉",
      links: {
        myWedding:              "My Wedding",
        myWeddingDesc:          "Set up details",
        guestListDesc:          "{{guests}} guests, {{families}} families",
        budgetDesc:             "{{count}} expenses tracked",
        websitePublished:       "Published",
        websiteSetup:           "Set up your site",
        settings:               "Settings",
        settingsDesc:           "Profile & account",
        guestList:              "Guest List",
        budgetLabel:            "Budget",
        websiteLabel:           "Website",
      },
      errors: {
        loadFailed:             "Failed to load dashboard.",
      },
    },
    photoWall: {
      gateTitle:                "Photo Wall",
      gateBlurb:                "Shared wedding photo wall for guests — available on Gold and Platinum plans.",
      gateFeat1:                "Live photo uploads from guests",
      gateFeat2:                "Album organisation",
      gateFeat3:                "Reactions and comments",
      gateFeat4:                "Slideshow mode",
      upgradeToGold:            "Upgrade to Gold",
      backToDashboard:          "Back to Dashboard",
      currentPlan:              "Current plan:",
      headerTitle:              "Guest Photo & Video Wall",
      slideshow:                "Slideshow",
      stop:                     "Stop",
      moderate:                 "Moderate",
      stats: {
        total:                  "Total",
        photos:                 "Photos",
        videos:                 "Videos",
        pending:                "Pending",
      },
      slideCount:               "{{idx}} / {{total}} • Click to exit",
      all:                      "All",
      featured:                 "⭐ Featured",
      noPhotosYetHeading:       "No photos yet",
      uploadFirstPhoto:         "Upload First Photo",
      byUploader:               "By {{name}}",
      viewsCount:               "{{count}} views",
      uploadTitle:              "Upload Media",
      photoVideoLabel:          "Photo / Video",
      urlPlaceholder:           "Paste image or video URL...",
      captionLabel:             "Caption",
      noAlbum:                  "No album",
      photoOpt:                 "Photo",
      videoOpt:                 "Video",
      uploading:                "Uploading...",
      uploadBtn:                "Upload",
      addAlbumTitle:            "📁 Create Album",
      titleLabel:               "Title",
      titlePlaceholder:         "e.g. Reception",
      descriptionLabel:         "Description",
      iconLabel:                "Icon",
      creating:                 "...",
      createBtn:                "Create",
      moderateTitle:            "🛡️ Moderate Uploads ({{count}} pending)",
      noCaption:                "No caption",
      guestBadge:               "GUEST",
      approve:                  "✓ Approve",
      reject:                   "✗ Reject",
      approveAll:               "Approve All ({{count}})",
      rejectAll:                "Reject All",
      shareTitle:               "📤 Share Photo Wall",
      createShareLink:          "Create Share Link",
      copyLink:                 "Copy link",
      openLink:                 "Open link",
      delAlbumTitle:            "Delete Album",
      delMediaTitle:            "Remove Media",
      delAlbumMsg:              "Are you sure you want to delete this album? This will not delete the photos inside, but they will no longer be grouped.",
      delMediaMsg:              "Are you sure you want to remove this photo/video from your gallery? This action cannot be undone.",
      unknownUploader:          "Unknown",
      guestFallback:            "Guest",
      toasts: {
        copied:                 "Copied",
        copiedBody:              "Link copied to clipboard!",
        albumDeleted:           "Album deleted successfully.",
        mediaRemoved:           "Media removed from gallery.",
        removedTitle:           "Removed",
        deleteFailedTitle:      "Delete Failed",
        deleteFailedBody:       "Failed to remove item.",
        albumErrorTitle:        "Album Error",
        albumFailed:            "Failed to create album",
        invalidUrlTitle:        "Invalid URL",
        invalidUrlBody:         "Please enter a valid URL or upload a file.",
        uploadFailedTitle:      "Upload Failed",
        uploadFailedDefault:    "Upload failed",
        uploadHint:             "Please ensure the URL points to an accessible image file (jpg, png, webp).",
      },
    },
    giftRegistry: {
      headerTitle:               "Gift Registry & Cash Gift Tracker",
      gateTitle:                 "Gift Registry",
      gateBlurb:                 "Create and manage your wedding gift registry — available on Gold and Platinum plans.",
      gateFeat1:                 "Add gifts from any store",
      gateFeat2:                 "Share registry link with guests",
      gateFeat3:                 "Track purchased gifts",
      gateFeat4:                 "Cash fund support",
      upgradeToGold:             "Upgrade to Gold",
      backToDashboard:           "Back to Dashboard",
      currentPlan:               "Current plan:",
      stats: {
        totalGifts:              "Total Gifts",
        cashReceived:            "Cash Received",
        fundRaised:              "Fund Raised",
        pendingThanks:           "Pending Thanks",
      },
      tabs: {
        funds:                   "Cash Funds",
        wishlist:                "Wishlist",
        cashGifts:               "Cash Gift Tracker",
        thankyou:                "Thank You List",
      },
      addFund:                   "Add Fund",
      contributors:              "{{count}} contributors",
      paymentLabelDefault:       "Payment",
      addItem:                   "Add Item",
      externalLink:              "External Link",
      markNThanked:              "Mark {{count}} Thanked",
      recordGift:                "Record Gift",
      thankYouListTitle:         "Thank You List",
      cols: {
        name:                    "Name",
        gift:                    "Gift",
        contact:                 "Contact",
        status:                  "Status",
      },
      thanked:                   "Thanked",
      thankPending:              "Pending",
      thankSent:                 "✅ Sent",
      thankPendingTitle:         "Click to mark as Pending",
      thankToSentTitle:          "Click to mark as Sent",
      thankToThankedTitle:       "Click to mark as Thanked",
      giftFallback:              "Gift",
      // Modals
      createFundTitle:           "💰 Create Cash Fund",
      titleLabel:                "Title",
      titlePlaceholder:          "e.g. Honeymoon Fund",
      descriptionLabel:          "Description",
      goalLabel:                 "Goal",
      iconLabel:                 "Icon",
      iconOptions: {
        cash:                    "Cash",
        vacation:                "Vacation",
        home:                    "Home",
        celebration:             "Celebration",
        travel:                  "Travel",
        education:                "Education",
        baby:                    "Baby",
        car:                     "Car",
      },
      paymentMethodLabel:        "Payment Method",
      selectPaymentMethod:       "Select Payment Method",
      paymentNoteLabel:          "Payment Note",
      creating:                  "...",
      createFund:                "Create Fund",
      addWishlistItemTitle:      "🎁 Add Wishlist Item",
      nameLabel:                 "Name",
      externalLinkLabel:         "External Link",
      externalLinkPlaceholder:   "https://store.com/product",
      addItemBtn:                "Add Item",
      recordGiftTitle:           "Record Gift / Cash Gift",
      guestNameLabel:            "Guest Name",
      selectGuest:               "Select guest...",
      typeOptions: {
        cash:                    "Cash",
        fund:                    "Fund Contribution",
        physical_gift:           "Physical Gift",
      },
      record:                    "Record",
      editWishlistItemTitle:     "✏️ Edit Wishlist Item",
      saveChanges:               "Save Changes",
      categoryPlaceholder:       "Category",
      pricePlaceholder:          "Price",
      statusLabelMod: "Status",
      statusOptions: {
        available:               "Available",
        reserved:                "Reserved",
        purchased:               "Purchased",
      },
      shareRegistryTitle:        "📤 Share Registry",
      createShareLink:           "Create Share Link",
      viewsCount:                "{{count}} views",
      ofGoal:                    "of {{amount}}",
      // Toasts/errors
      toasts: {
        copied:                  "Copied",
        copiedBody:              "Link copied to clipboard!",
      },
      errors: {
        deleteConfirm:           "Delete?",
        fundFailed:              "Failed to create fund.",
        itemFailed:              "Failed to add registry item.",
        contribFailed:           "Failed to add contribution.",
        thankFailed:             "Could not update thank-you status.",
        itemUpdateFailed:        "Failed to update item.",
        fundErrorTitle:          "Fund Error",
        itemErrorTitle:          "Item Error",
        contribErrorTitle:       "Contribution Error",
        updateFailedTitle:       "Update Failed",
        updateErrorTitle:        "Update Error",
      },
    },
    budget: {
      seoTitle:                "Budget",
      pageTitle:               "Budget Planner",
      summaryLine:             "{{items}} expenses across {{cats}} categories",
      deleteSelected:          "Delete Selected ({{count}})",
      addExpense:              "Add Expense",
      weddingCancelledTitle:   "This wedding has been cancelled.",
      weddingCancelledDesc:    "The page is in read-only mode.",
      totalBudget:             "Total Budget",
      overBy:                  "Over by ",
      remaining:               "Remaining: ",
      spentLine:               "Spent: {{amount}} ({{pct}}%)",
      paidLine:                "Paid: {{amount}}",
      stats: {
        totalEstimated:        "Total Estimated",
        totalActual:           "Total Actual",
        totalPaid:             "Total Paid",
        outstanding:           "Outstanding",
      },
      tabByCategory:           "By Category",
      tabAllExpenses:          "All Expenses ({{count}})",
      noExpensesYet:           "No expenses yet.",
      addFirstExpense:         "Add First Expense",
      pctOfSpend:              "{{pct}}% of total spend",
      catPaidLine:             "Paid: {{amount}} ({{pct}}%)",
      addToCategory:           "Add to {{category}}",
      descriptionLabel:        "Description:",
      notesLabel:              "Notes:",
      allCategories:           "All Categories",
      expenseCol:              "Expense",
      actionCol:               "Action",
      noExpensesFound:         "No expenses found.",
      vendorBookingTitle:      "Vendor Booking",
      addExpenseTitle:         "Add Expense",
      editExpenseTitle:        "Edit Expense",
      recordPaymentTitle:      "Record Payment",
      bookingNoticeBody:       "This is a vendor booking. Update the paid amount to track your payments.",
      nameLabel:               "Name",
      namePlaceholder:         "e.g. Bridal Lehenga",
      categoryLabel:           "Category",
      selectCategory:          "Select category...",
      bookingLabel:            "Booking",
      vendorLabel:             "Vendor",
      bookingTotalLabel:       "Booking Total",
      estimatedCostLabel:      "Estimated Cost",
      actualCostLabel:         "Actual Cost",
      paidAmountLabel:         "Paid Amount",
      statusLabel:             "Status",
      dueDateLabel:            "Due Date",
      vendorPlaceholder:       "Select or type...",
      descriptionPlaceholder:  "Brief description",
      notesPlaceholder:        "Any notes...",
      updatePayment:           "Update Payment",
      saveChanges:             "Save Changes",
      delTitleBulk:            "Delete Selected Items",
      delTitleOne:             "Remove Expense",
      delMsgBulk:              "Are you sure you want to delete {{count}} selected items? This will update your total spending and remaining budget.",
      delMsgOne:               "Are you sure you want to remove \"{{name}}\" from your budget? This action will also update your total spending and remaining budget.",
      emptyHeading:            "Wedding Budget Planner",
      emptyBlurb:              "Track every expense, manage vendor payments, and stay on top of your wedding budget — all in one place.",
      emptyFeat1:              "Set your total wedding budget",
      emptyFeat2:              "Track expenses by category",
      emptyFeat3:              "Monitor vendor payments",
      emptyFeat4:              "See who's paying for what",
      emptyHint:               "Create a wedding first to start tracking your budget.",
      createWedding:           "Create Wedding",
      backToDashboard:         "Back to Dashboard",
      validation: {
        nameRequired:          "Name is required.",
        categoryRequired:      "Category is required.",
        estimatedRequired:     "Estimated cost is required.",
        invalidBudget:         "Enter a valid budget amount.",
      },
      toasts: {
        budgetUpdated:         "Budget updated.",
        bookingPaymentUpdated: "Booking payment updated.",
        expenseUpdated:        "Expense updated.",
        expenseAdded:          "Expense added.",
        nItemsRemoved:         "{{count}} items removed.",
        nameRemoved:           "{{name}} removed.",
      },
      errors: {
        loadFailed:            "Failed to load budget.",
        budgetUpdateFailed:    "Failed to update budget.",
        saveFailed:            "Failed to save.",
        removeFailed:          "Failed to remove item(s).",
      },
    },
    guests: {
      seoTitle:               "Guest List",
      pageTitle:              "Guest List",
      countLine_one:          "{{count}} guest",
      countLine_other:        "{{count}} guests",
      groomSide:              "Groom's Side",
      brideSide:              "Bride's Side",
      deleteSelected:         "Delete Selected ({{count}})",
      clearAllGuests:         "Clear all guests",
      mealAlertTitle:         "Set Meal Preferences:",
      mealAlertBody:          "Click {{edit}} on any guest and fill in the {{meal}} field to track catering choices.",
      weddingCancelledTitle:  "This wedding has been cancelled.",
      weddingCancelledDesc:   "The page is in read-only mode.",
      stats: {
        totalGuests:          "Total Guests",
        attending:            "Attending",
        pending:              "Pending",
        declined:             "Declined",
      },
      tabGuests:              "Guests",
      tabFamilies:            "Families ({{count}})",
      tabRsvp:                "RSVP Overview",
      searchPlaceholder:      "Search name, email, phone...",
      mealPrefCol:            "Meal Pref.",
      noFiltersMatch:         "No guests match your filters.",
      noGuestsYet:            "No guests yet. Click \"Add Guest\" to start.",
      childBadge:             "Child",
      pageNum:                "Page {{page}} of {{total}}",
      prev:                   "Prev",
      next:                   "Next",
      familyTitle:            "{{name}} Family",
      memberCount_one:        "{{count}} member",
      memberCount_other:      "{{count}} members",
      rsvpDone:               "RSVP ✓",
      loading:                "Loading...",
      noEventsMessage:        "No events. Add events in the Website builder to see RSVP responses.",
      yes:                    "Yes",
      no:                     "No",
      pending:                "Pending",
      addGuestTitle:          "Add Guest",
      editGuestTitle:         "Edit Guest",
      firstNamePlaceholder:   "First name",
      lastNamePlaceholder:    "Last name",
      emailLabel:             "Email",
      emailPlaceholder:       "email@example.com",
      phoneLabel:             "Phone",
      phonePlaceholder:       "98765 43210",
      groupSideLabel:         "Group / Side",
      selectGroup:            "Select a group…",
      otherSpecify:           "Other (specify)",
      groupCustomPlaceholder: "e.g. Friends, Colleagues",
      familyGroupLabel:       "Family Group",
      noFamilyGroup:          "No family group",
      dietaryLabel:           "Dietary Restrictions",
      dietaryPlaceholder:     "e.g. Vegetarian",
      hotelDetails:           "For the hotel",
      hotelDetailsHint:       "Guests can fill these in themselves from their itinerary link. No ID numbers or copies are ever stored.",
      idNameLabel:            "Name as on ID",
      idTypeLabel:            "ID they will bring",
      nationalityLabel:       "Nationality",
      chooseOption:           "Choose…",
      specialRequestsLabel:   "Anything the welcome team should know?",
      whatsappOptedIn:        "Asked for WhatsApp updates",
      mealLabel:              "Meal Preference",
      mealSetThis:            "Set this!",
      mealOptions: {
        none:                 "No preference",
        veg:                  "Vegetarian",
        non_veg:              "Non-Vegetarian",
        vegan:                "Vegan",
        jain:                 "Jain",
        eggetarian:           "Eggetarian",
        halal:                "Halal",
        kosher:               "Kosher",
      },
      tableLabel:             "Table Number",
      tablePlaceholder:       "e.g. 5",
      plusOnesLabel:          "Plus Ones",
      childSwitch:            "Child",
      rsvpStatusLabel:        "RSVP Status",
      notesLabel:             "Notes",
      notesPlaceholder:       "Special notes...",
      saveChanges:            "Save Changes",
      addGuest:               "Add Guest",
      editFamilyTitle:        "Edit Family Group",
      createFamilyTitle:      "Create Family Group",
      familyNameLabel:        "Family Name",
      familyNamePlaceholder:  "e.g. Sharma",
      familyNotesPlaceholder: "Optional notes...",
      familySave:             "Save",
      familyCreate:           "Create",
      importTitle:            "Import Guests from CSV",
      importInfoFmt:          "CSV Format:",
      importInfoBody:         " Header row with columns: firstName, lastName, email, phone, group, familyName, isChild, dietaryRestrictions, tableNumber, notes, plusOnes",
      importInfoNote:         "Only firstName is required. Family groups auto-created from familyName.",
      uploadLabel:            "Upload CSV File",
      pasteLabel:             "Or paste CSV data",
      pasteCsvPlaceholder:    "firstName,lastName,email,group,familyName\nRaj,Sharma,raj@email.com,Groom's Side,Sharma",
      detectedCount:          "{{count}} guest(s) detected",
      importing:              "Importing...",
      importN:                "Import {{count}} Guests",
      delTitleAll:            "Clear All Guests",
      delTitleBulk:           "Delete Selected Guests",
      delTitleOne:            "Delete Guest",
      delMsgAll:              "Permanently remove all {{count}} guest(s) from this wedding? Their RSVPs and assigned family details will be cleared. Family groups themselves are kept so you can re-import. This cannot be undone.",
      delMsgBulk:             "Are you sure you want to delete {{count}} selected guests? This action cannot be undone.",
      delMsgOne:              "Are you sure you want to remove this guest from the list? Their RSVP status and assigned family details will be lost.",
      removeFamilyConfirm:    "Remove \"{{name}}\" family? Guests will be unlinked.",
      // Toasts and validation
      toasts: {
        guestUpdated:         "Guest updated.",
        guestAdded:           "Guest added.",
        guestRemoved:         "Guest removed.",
        nGuestsRemoved:       "{{count}} guests removed.",
        noGuestsToRemove:     "No guests to remove.",
        familyUpdated:        "Family updated.",
        familyCreated:        "Family created.",
        familyRemoved:        "Family removed.",
        exported:             "Exported.",
      },
      validation: {
        firstNameRequired:    "First name is required.",
        lastNameRequired:     "Last name is required.",
        phoneRequired:        "Phone number is required.",
        phoneIndian:          "Indian mobile numbers must be exactly 10 digits.",
        phoneRange:           "Phone number must be 7–15 digits.",
        emailInvalid:         "Please enter a valid email address.",
        emailExists:          "This email is already registered.",
        phoneExists:          "This phone number is already registered.",
        nameExists:           "A guest with this name already exists.",
        familyNameRequired:   "Family name is required.",
        fixErrors:            "Please fix the errors below.",
        invalidFamily:        "Invalid family group selection.",
      },
      errors: {
        loadFailed:           "Failed to load guests.",
        saveFailed:           "Failed to save guest.",
        removeFailed:         "Failed to remove guest(s).",
        familySaveFailed:     "Failed to save family.",
        familyRemoveFailed:   "Failed to remove family.",
        importFailed:         "Import failed.",
        importNoRows:         "No valid rows. Ensure CSV has header with \"firstName\" column.",
        exportFailed:         "Export failed.",
        exportEmpty:          "No guests to export.",
      },
    },
  },

  vendor: {
    dashboard: {
      welcome:               "Welcome back, {{name}}!",
      viewAll:               "View All →",
      noBookings:            "No bookings yet",
      bookingNumber:         "Booking #",
      eventDate:             "Event Date",
      stats: {
        totalBookings:       "Total Bookings",
        pendingInquiries:    "Pending Inquiries",
        upcomingEvents:      "Upcoming Events",
        revenue:             "Revenue",
        pending:             "Pending",
        rating:              "Rating",
        confirmedCount:      "{{count}} confirmed",
        reviewsCount:        "{{count}} reviews",
      },
      actions: {
        editProfile:    { label: "Edit Profile",    desc: "Update your business info" },
        manageBookings: { label: "Manage Bookings", desc: "{{count}} pending" },
        calendar:       { label: "Calendar",        desc: "View your schedule" },
        messages:       { label: "Messages",        desc: "Chat with couples" },
        settings:       { label: "Settings",        desc: "Account preferences" },
        portfolio:      { label: "Portfolio",       desc: "Showcase your work" },
      },
      errors: {
        accessDenied:           "Access denied. Your account may not have vendor permissions. Please log out and log back in.",
        profileMissing:         "Vendor profile not found. Please complete your Business Profile first.",
        loadFailed:             "Failed to load dashboard data. Please refresh the page.",
        loadFailedShort:        "Failed to load dashboard.",
        statsAccessDenied:      "Access denied loading stats. Please log out and log back in.",
        bookingsAccessDenied:   "Access denied loading bookings. Please log out and log back in.",
      },
    },
    subscription: {
      // Page chrome
      heading:                "Subscription Plans",
      // Billing toggle
      monthly:                "Monthly",
      yearly:                 "Yearly",
      savePercent:            "Save {{pct}}%",
      // Current plan banner
      tierPlan:               "{{tier}} Plan",
      activeUntil:            "Active until {{date}}",
      willNotRenewSuffix:     " · Will not renew",
      // Plan card price area
      priceFree:              "Free",
      perMonthSuffix:         "/mo",
      perYearSuffix:          "/yr",
      billedAnnually:         "${{amount}} / month, billed annually",
      // Plan card actions
      upgradeTo:              "Upgrade to {{name}}",
      // Shown instead of the upgrade button when card payments aren't set up
      // for this plan yet, so nobody clicks a button that can only fail.
      notAvailableYet:        "Not available yet",
      notAvailableYetHint:    "Card payments for this plan aren't switched on yet. Contact us and we'll set you up.",
      // Cancel flow
      confirmCancel:          "Are you sure you want to cancel? You'll keep access until your billing period ends.",
      // Toasts
      toasts: {
        activated:               "Your subscription has been activated.",
        checkoutCancelled:       "Checkout was cancelled. No charges were made.",
        subscriptionCancelled:   "Subscription cancelled. You'll retain access until the end of your billing period.",
        // Dev-mode warning when vendor Stripe price IDs aren't configured.
        // Interpolation: {tierLabel} = capitalised tier name, {tier} = slug,
        // {intervalKey} = monthly|yearly. Long but kept whole so it's
        // translatable as one piece per language without losing intent.
        devMode:                 "DEV MODE — {{tierLabel}} plan activated locally. No payment was collected. Vendor Stripe Price IDs are not configured yet; an admin needs to set stripe_vendor_price_{{tier}}_{{intervalKey}} in Super Admin → Integrations → Stripe before real billing can run.",
      },
    },
    profile: {
      // Page chrome
      title:                 "Vendor Profile",
      createTitle:           "Create Vendor Profile",
      verifiedBadge:         "Verified ✓",
      setupHeading:          "Set up your vendor profile",
      setupSubheading:       "Tell us about your business to get started.",
      // Field labels
      businessName:          "Business Name",
      tagline:               "Tagline",
      website:               "Website",
      // vendors.email is the contact address on the public listing, not the
      // users.email login credential — the label has to say so, because
      // vendors changed it here expecting sign-in to follow and got locked out.
      publicContactEmail:     "Public contact email",
      publicContactEmailHint: "Shown to couples on your public listing. This is not your login email.",
      changeLoginEmailLink:   "Change your login email in Settings",
      services:              "Services (comma-separated)",
      zip:                   "ZIP Code",
      priceRange:            "Price Range",
      startingPrice:         "Starting Price ($)",
      // Create-profile flow
      selectCategory:        "Select a category…",
      createSubmit:          "Create Profile",
      creating:              "Creating…",
      // Tabs
      tabs: {
        info:                "Business Info",
        packages:            "Packages",
      },
      // Packages tab
      packagesIntro:         "Define the packages you offer. Each package has a name, price, description, and a list of features.",
      packagesEmpty:         "No packages yet. Add your first package to showcase your offerings.",
      addPackage:            "Add Package",
      packageNumber:         "Package {{n}}",
      packageName:           "Package Name",
      packagePrice:          "Price ($)",
      packageFeatures:       "Features (comma-separated)",
      savePackages:          "Save Packages",
      // Photos tab
      portfolioPhotos:       "Portfolio Photos",
      photosEmpty:           "No photos uploaded yet.",
      addPhotoLabel:         "Add a photo",
      addPhotoPlaceholder:   "Click or drag & drop to add a portfolio photo",
      // Toasts
      toasts: {
        updated:               "Profile updated.",
        updateFailed:          "Failed to update.",
        photosSaved:           "Photos saved.",
        photosSaveFailed:      "Failed to save photos.",
        photoSaveFailed:       "Failed to save photo.",
        packagesUpdated:       "Packages updated.",
        packagesUpdateFailed:  "Failed to update packages.",
        packageNameRequired:   "Each package must have a name.",
        created:               "Profile created! You can now fill in your full details.",
        createFailed:          "Failed to create profile.",
      },
    },
    bookings: {
      seoTitle:               "Vendor Bookings",
      stats: {
        total:                "Total",
        pending:              "Pending",
        confirmed:            "Confirmed",
        revenue:              "Revenue",
      },
      allStatuses:            "All Statuses",
      empty:                  "No bookings",
      emptyFiltered:          "No bookings with this status.",
      emptyDefault:           "You haven't received any bookings yet.",
      cols: {
        bookingNumber:        "Booking #",
        couple:               "Couple",
        eventDate:            "Event Date",
        guests:               "Guests",
      },
      pagePos:                "Page {{page}} of {{total}}",
      prev:                   "← Prev",
      next:                   "Next →",
      detailTitle:            "Booking Details",
      details: {
        guestCount:           "Guest Count",
        quotedPrice:          "Quoted Price",
        agreedPrice:          "Agreed Price",
        advancePaid:          "Advance Paid",
        notes:                "Notes",
      },
      confirmBooking:         "Confirm Booking",
      decline:                "Decline",
      confirmStatusChange:    "Change booking status to \"{{status}}\"?",
      bookingNowStatus:       "Booking {{status}}.",
      errors: {
        loadFailed:           "Failed to load bookings.",
        updateFailed:         "Failed to update.",
      },
    },
    analytics: {
      headerTitle:            "Vendor Analytics",
      subtitle:               "{{businessName}} • {{category}} — Last 30 days performance",
      stats: {
        profileViews:         "Profile Views",
        inquiries:            "Inquiries",
        bookings:             "Bookings",
        totalRevenue:         "Total Revenue",
      },
      funnelTitle:            "Inquiry-to-Booking Funnel",
      funnel: {
        views:                "Views",
        inquiries:            "Inquiries",
        responded:            "Responded",
        accepted:             "Accepted",
        booked:               "Booked",
      },
      overallConversion:      "Overall Conversion:",
      responseRate:           "Response Rate:",
      benchmarksTitle:        "Competitor Benchmarks",
      benchmarksContext:      "vs {{count}} {{category}} vendors in {{region}}",
      benchmarkRows: {
        rating:               "Rating",
        reviews:              "Reviews",
        startingPrice:        "Starting Price",
      },
      youLabel:               "You:",
      avgLabel:               "Avg:",
      topPercentile:          "Top {{pct}}%",
      priceTier: {
        unknown:              "Unknown",
        budget:               "Budget:",
        moderate:             "Moderate:",
        premium:              "Premium:",
      },
      seasonalTitle:          "Seasonal Demand Forecast",
      monthDemandTooltip:     "{{month}}: {{pct}}% demand",
      trendTitle:             "Inquiry Trend (30 days)",
      totalInquiries:         "{{count}} total inquiries",
      growthTipsTitle:        "Growth Tips",
      tips: {
        improveResponseTitle: "Improve Response Rate",
        improveResponseDesc:  "Your response rate is {{pct}}%. Respond to inquiries within 2 hours to earn the \"Fast Responder\" badge.",
        boostRatingTitle:     "Boost Your Rating",
        boostRatingDesc:      "Your rating is {{rating}}. Ask satisfied clients to leave reviews. Top-rated vendors get 40% more inquiries.",
        improveConvTitle:     "Improve Conversions",
        improveConvDesc:      "Try offering package deals or seasonal discounts to convert more inquiries into bookings.",
        updatePortfolioTitle: "Update Your Portfolio",
        updatePortfolioDesc:  "Vendors with 20+ photos get 2x more inquiries. Add recent work to your portfolio.",
        getVerifiedTitle:     "Get Verified",
        getVerifiedDesc:      "Verified vendors rank higher in search results and earn couples' trust faster.",
      },
    },
    crm: {
      seoTitle:               "Lead Pipeline & CRM",
      headerTitle:            "Lead Pipeline & CRM",
      subtitle:               "Track inquiries from first contact to booked",
      newLead:                "New Lead",
      stats: {
        totalLeads:           "Total Leads",
        pipelineValue:        "Pipeline Value",
        conversionRate:       "Conversion Rate",
        followUpsDue:         "Follow-Ups Due",
      },
      stages: {
        inquiry:              "Inquiry",
        quote_sent:           "Quote Sent",
        negotiation:          "Negotiation",
        booked:               "Booked",
        completed:            "Completed",
        lost:                 "Lost",
      },
      followUpDue:            "Follow-up due",
      noLeads:                "No leads",
      dropHere:               "Drop here",
      stageUpdateFailed:      "Could not move lead. Try again.",
      editLeadTitle:          "Edit Lead",
      newLeadTitle:           "New Lead",
      contactNameLabel:       "Contact Name",
      contactNameRequired:    "Contact Name is required.",
      contactEmailLabel:      "Email",
      contactEmailInvalid:    "Please enter a valid email address.",
      contactPhoneLabel:      "Phone",
      contactPhoneInvalidChars: "Phone can only contain digits, spaces, +, -, and parentheses.",
      contactPhoneInvalidLength: "Phone number must be 7 to 15 digits.",
      weddingDatePast:        "Wedding date can't be in the past.",
      followUpDatePast:       "Follow-up date can't be in the past.",
      stageLabel:             "Stage",
      priorityLabel:          "Priority",
      priorityHot:            "Hot 🔥",
      sourceLabel:            "Source",
      sources: {
        platform:             "Platform",
        website:              "Website",
        referral:             "Referral",
        social_media:         "Social Media",
        phone:                "Phone",
        other:                "Other",
      },
      estimatedBudgetLabel:   "Estimated Budget",
      quoteAmountLabel:       "Quote Amount",
      followUpDateLabel:      "Follow-Up Date",
      notesLabel:             "Notes",
      saving:                 "Saving…",
      update:                 "Update",
      create:                 "Create",
      deleteConfirm:          "Delete this lead?",
    },
    team: {
      headerTitle:            "Team Management",
      membersCount:           "{{members}} members · {{available}} available",
      addMember:              "Add Member",
      stats: {
        totalTeam:            "Total Team",
        available:            "Available",
        unavailable:          "Unavailable",
        avgRate:              "Avg Rate",
      },
      available:              "Available",
      unavailable:            "Unavailable",
      edit:                   "Edit",
      empty:                  "No team members yet. Add your staff to assign them to bookings!",
      addMemberTitle:         "Add Team Member",
      editMemberTitle:        "Edit Team Member",
      nameLabel:              "Name",
      nameRequired:           "Name is required",
      roleLabel:              "Role",
      emailLabel:             "Email",
      phoneLabel:             "Phone",
      phonePlaceholder:       "e.g., +1 555-123-4567",
      phoneInvalid:           "Phone number must be 7-15 digits.",
      specializationLabel:    "Specialization",
      specializationPlaceholder: "e.g., Event photography, Lighting",
      hourlyRateLabel:        "Hourly Rate ($)",
      notesLabel:             "Notes",
      availableSwitch:        "Available for assignments",
      addMemberAction:        "Add Member",
      updateMember:           "Update Member",
      removeConfirm:          "Remove this team member?",
      msgAdded:               "Team member added!",
      msgUpdated:             "Updated!",
    },
    portfolio: {
      headerTitle:            "Portfolio Builder",
      itemsCount:             "{{items}} items · {{featured}} featured",
      filterAll:              "All",
      featured:               "Featured",
      private:                "Private",
      untitled:               "Untitled",
      emptyState:             "No portfolio items yet. Click \"Add Item\" to showcase your work!",
      edit:                   "Edit",
      addItemTitle:           "Add Portfolio Item",
      editItemTitle:          "Edit Portfolio Item",
      typeLabel:              "Type",
      titleLabel:             "Title",
      titlePlaceholder:       "e.g., Johnson-Patel Wedding",
      descriptionLabel:       "Description",
      imageLabel:             "Image",
      videoUrlLabel:          "Video URL",
      clientNameLabel:        "Client Name",
      eventDateLabel:         "Event Date",
      venueLabel:             "Venue",
      testimonialTextLabel:   "Testimonial Text",
      ratingLabel:            "Rating",
      awardNameLabel:         "Award Name",
      yearLabel:              "Year",
      tagsLabel:              "Tags (comma-separated)",
      tagsPlaceholder:        "outdoor, rustic, garden",
      featuredSwitch:         "Featured",
      publicSwitch:           "Public",
      addItem:                "Add Item",
      updateItem:             "Update Item",
      removeConfirm:          "Remove this item?",
      msgUpdated:             "Updated!",
      msgAdded:               "Added to portfolio!",
    },
    quotes: {
      seoTitle:               "Quote Requests",
      title:                  "Quote Requests",
      subtitle:               "Respond to incoming enquiries from couples",
      awaitingResponse:       "{{count}} awaiting response",
      filterAll:              "All",
      empty:                  "No quote requests yet.",
      emptyDesc:              "When couples request quotes, they'll appear here.",
      cols: {
        couple:               "Couple",
        eventDate:            "Event Date",
        budget:               "Budget",
        requested:            "Requested",
        yourQuote:            "Your Quote",
      },
      editQuote:              "Edit Quote",
      respond:                "Respond",
      requirements:           "Requirements — {{name}}",
      reqGuests:              "Guests:",
      reqVenue:               "Venue:",
      reqStyle:               "Style:",
      reqNotes:               "Notes:",
      sendQuoteTitle:         "Send Quote — {{name}}",
      yourQuoteAmount:        "Your Quote Amount ($)",
      quoteAmountPlaceholder: "e.g. 2500",
      quoteDetailsLabel:      "Quote Details / Package Description",
      quoteDetailsPlaceholder:"Describe what's included in your quote...",
      validUntil:             "Valid Until",
      sending:                "Sending...",
      sendQuote:              "Send Quote",
      submitFailed:           "Failed to submit quote. Please try again.",
      loadFailed:              "Failed to load quote requests.",
      planBlocked: {
        defaultMessage:        "This feature requires a paid plan.",
        youreOnPlan:          "You're on the {{current}} plan. Upgrade to {{required}} or above to receive quote requests from couples and respond with custom pricing.",
        feat1:                "See couples' wedding details + budget",
        feat2:                "Send tailored quotes with package pricing",
        feat3:                "Track pending, accepted, and declined quotes",
        feat4:                "Convert accepted quotes into bookings automatically",
        upgradePlan:          "Upgrade Plan",
        backToDashboard:      "Back to Dashboard",
      },
    },
  },

  vendorPortal: {
    dashboard: "Vendor Dashboard", editProfile: "Edit Profile",
    totalBookings: "Total Bookings", pending: "Pending", confirmed: "Confirmed",
    rating: "Rating", recentBookings: "Recent Bookings", quickActions: "Quick Actions",
    profileTitle: "My Profile", businessInfo: "Business Info",
    saveChanges: "Save Changes", bookingsTitle: "Bookings",
    calendarTitle: "Calendar", revenue: "Revenue",
    subscription: {
      subscriptionPlans:    "Subscription Plans",
      upgradeYourProfileTo: "Upgrade your profile to reach more couples.",
      currentPlan:          "Current Plan",
      cancelPlan:           "Cancel Plan",
      downgrade:            "Downgrade"
    }
  },
  admin: {
    "adminAnalytics.adminAnalytics": "Admin Analytics",
    "adminAnalytics.business": "Business",
    "adminAnalytics.comprehensivePlatformPerforman": "Comprehensive platform performance metrics",
    "adminAnalytics.id": "ID",
    "adminAnalytics.monthlyRevenue": "Monthly Revenue",
    "adminAnalytics.monthlyUserSignups": "Monthly User Signups",
    "adminAnalytics.noRevenueDataYet": "No revenue data yet",
    "adminAnalytics.noVendorData": "No vendor data",
    "adminAnalytics.vendorPerformance": "Vendor Performance",
    "auditLog.action": "Action",
    "auditLog.detail": "Detail",
    "auditLog.entity": "Entity",
    "auditLog.ip": "IP",
    "auditLog.searchByUserOr": "Search by user or detail...",
    "auditLog.time": "Time",
    "auditLog.user": "User",
    "bannerManager.activate": "Activate",
    "bannerManager.add": "Add",
    "bannerManager.addCity": "Add city...",
    "bannerManager.analytics": "Analytics",
    "bannerManager.bannerManager": "Banner Manager",
    "bannerManager.claimOffer": "Claim Offer",
    "bannerManager.clickthroughRate": "Click-Through Rate",
    "bannerManager.createTimelimitedBannersWith": "Create time-limited banners with targeting rules and click analytics",
    "bannerManager.createYourFirstPromotional": "Create your first promotional banner to get started.",
    "bannerManager.dailyEventsLast30": "Daily Events (Last 30 Days)",
    "bannerManager.delete": "Delete",
    "bannerManager.duplicate": "Duplicate",
    "bannerManager.edit": "Edit",
    "bannerManager.egDiwaliWeddingSeason": "E.g. Diwali Wedding Season Sale",
    "bannerManager.leaveEmptyForSolid": "Leave empty for solid",
    "bannerManager.newHotDeal": "NEW, 🔥 HOT DEAL",
    "bannerManager.noBannersFound": "No banners found",
    "bannerManager.pause": "Pause",
    "bannerManager.preview": "Preview",
    "bannerManager.promoDescription": "Promo description...",
    "bannerManager.promotionalBanners": "Promotional Banners",
    "bannerManager.resume": "Resume",
    "bannerManager.searchBanners": "Search banners...",
    "bannerManager.topClickedPages": "Top Clicked Pages",
    "bannerManager.userfacingHeadlineText": "User-facing headline text",
    "bookings.actions": "Actions",
    "bookings.booking": "Booking #",
    "bookings.eventDate": "Event Date",
    "bookings.guests": "Guests",
    "bookings.noBookingsFound": "No bookings found",
    "bookings.searchBookings": "Search bookings...",
    "bookings.status": "Status",
    "bookings.total": "Total",
    "bookings.update": "Update",
    "bookings.vendor": "Vendor",
    "broadcast.emailBroadcast": "Email Broadcast",
    "broadcast.enterEmailSubject": "Enter email subject...",
    "broadcast.forALimitedTime": "For a limited time, enjoy 30% off all premium plans...",
    "broadcast.itsBeenAWhile": "It's been a while since we've seen you. Your wedding plans are waiting!",
    "broadcast.subject": "Subject:",
    "broadcast.targetAudience": "Target Audience",
    "broadcast.templates": "Templates",
    "broadcast.wedLoveYourFeedback": "We'd love your feedback to make VowsEra even better...",
    "broadcast.wereThrilledToAnnounce": "We're thrilled to announce a new feature...",
    "broadcast.weveMadeSomeImprovements": "We've made some improvements to make your experience better...",
    "broadcast.yourContentHere": "Your content here...",
    "bulkActions.bulkActions": "Bulk Actions",
    "bulkActions.business": "Business",
    "bulkActions.category": "Category",
    "bulkActions.chooseAction": "Choose Action",
    "bulkActions.email": "Email",
    "bulkActions.name": "Name",
    "bulkActions.notificationMessage": "Notification message",
    "bulkActions.notificationTitle": "Notification title",
    "bulkActions.plan": "Plan",
    "bulkActions.rating": "Rating",
    "bulkActions.role": "Role",
    "bulkActions.search": "Search...",
    "bulkActions.verified": "Verified",
    "categories.actions": "Actions",
    "categories.icon": "Icon",
    "categories.name": "Name",
    "categories.noCategoriesFound": "No categories found",
    "categories.slug": "Slug",
    "categories.vendors": "Vendors",
    "contentModeration.additionalDetailsOptional": "Additional details (optional)...",
    "contentModeration.confirm": "Confirm",
    "contentModeration.contentModerationAdmin": "Content Moderation — Admin",
    "contentModeration.noModerationActivityYet": "No moderation activity yet.",
    "contentModeration.queueEmpty": "Queue empty!",
    "contentModeration.reviewAndModerateUsergenerated": "Review and moderate user-generated content across the platform",
    "dashboard.adminDashboard": "Admin Dashboard",
    "dashboard.avgRating": "Avg Rating",
    "dashboard.conversionRate": "Conversion Rate",
    "dashboard.paidUsers": "Paid Users",
    "dashboard.planDistribution": "Plan Distribution",
    "dashboard.thisMonth": "This Month",
    "dashboard.thisWeek": "This Week",
    "dashboard.topCategories": "Top Categories",
    "dashboard.totalRevenue": "Total Revenue",
    "dashboard.verifiedVendors": "Verified Vendors",
    "dataExport.clickPreviewToSee": "Click \"Preview\" to see a sample of the data before exporting",
    "dataExport.dataExport": "Data Export",
    "dataExport.fields": "Fields:",
    "dataExport.selectData": "Select Data",
    "featureFlags.featureFlags": "Feature Flags",
    "featureFlags.searchFeatures": "Search features...",
    "featureRoadmap.completed": "Completed",
    "featureRoadmap.effort": "Effort:",
    "featureRoadmap.est": "Est:",
    "featureRoadmap.featureRoadmapSuperAdmin": "Feature Roadmap — Super Admin",
    "featureRoadmap.filesBuilt": "Files Built:",
    "featureRoadmap.inProgress": "In Progress",
    "featureRoadmap.keyInvestorMetricsThese": "Key Investor Metrics These Features Enable",
    "featureRoadmap.overallProgress": "Overall Progress",
    "featureRoadmap.phase56Development": "Phase 5 & 6 Development Effort",
    "featureRoadmap.planned": "Planned",
    "featureRoadmap.roles": "Roles:",
    "featureRoadmap.searchFeatures": "Search features...",
    "featureRoadmap.totalFeatures": "Total Features",
    "galleryModeration.approve": "Approve",
    "galleryModeration.approveAsFeatured": "Approve as Featured",
    "galleryModeration.archive": "Archive",
    "galleryModeration.egPleaseAddAt": "E.g. Please add at least 5 photos and a cover image...",
    "galleryModeration.galleryModeration": "Gallery Moderation",
    "galleryModeration.noGalleriesMatchThe": "No galleries match the current filter.",
    "galleryModeration.noSubmissionsFound": "No submissions found",
    "galleryModeration.reject": "Reject",
    "galleryModeration.reviewAndManageWedding": "Review and manage wedding gallery submissions",
    "galleryModeration.searchByTitleOr": "Search by title or city...",
    "galleryModeration.toggleFeatured": "Toggle Featured",
    "galleryModeration.vendorCredits": "Vendor Credits:",
    "galleryModeration.view": "View",
    "liveDocs.livingDocumentationRoleExpansi": "Living documentation — Role Expansion & Feature Plan",
    "liveDocs.overallProgress": "Overall Progress",
    "platformMetrics.bookingActivity": "Booking Activity",
    "platformMetrics.bookingStatuses": "Booking Statuses",
    "platformMetrics.deepAnalyticsAcrossAll": "Deep analytics across all platform dimensions",
    "platformMetrics.monthlyRevenue": "Monthly Revenue",
    "platformMetrics.monthlySignupTrend": "Monthly Signup Trend",
    "platformMetrics.planDistribution": "Plan Distribution",
    "platformMetrics.platformMetrics": "Platform Metrics",
    "platformMetrics.revenueTrend12Months": "Revenue Trend (12 months)",
    "platformMetrics.roleDistribution": "Role Distribution",
    "platformMetrics.topVendorCategories": "Top Vendor Categories",
    "platformMetrics.unableToLoadMetrics": "Unable to load metrics",
    "platformMetrics.userGrowth12Months": "User Growth (12 months)",
    "revenue.campaign": "Campaign",
    "revenue.couplePlanDistribution": "Couple Plan Distribution",
    "revenue.coupleRevenue": "Couple Revenue:",
    "revenue.dripCampaignManager": "Drip Campaign Manager",
    "revenue.lastRunResults": "Last Run Results:",
    "revenue.platformMonetizationMetricsGro": "Platform monetization metrics & growth analytics",
    "revenue.revenueDashboard": "Revenue Dashboard",
    "revenue.status": "Status",
    "revenue.steps": "Steps",
    "revenue.trigger": "Trigger",
    "revenue.userConversionFunnel": "User Conversion Funnel",
    "revenue.vendorRevenue": "Vendor Revenue:",
    "revenue.vendorTierDistribution": "Vendor Tier Distribution",
    "reviews.actions": "Actions",
    "reviews.approve": "Approve",
    "reviews.comment": "Comment",
    "reviews.date": "Date",
    "reviews.flag": "Flag",
    "reviews.noReviewsMatchYour": "No reviews match your filters",
    "reviews.rating": "Rating",
    "reviews.reject": "Reject",
    "reviews.reviewModeration": "Review Moderation",
    "reviews.reviewer": "Reviewer",
    "reviews.searchByReviewerVendor": "Search by reviewer, vendor, or content...",
    "reviews.status": "Status",
    "reviews.vendor": "Vendor",
    "reviews.view": "View",
    "settings.platformwideConfiguration": "Platform-wide configuration",
    "systemHealth.cpuLoad1m5m15m": "CPU Load (1m/5m/15m)",
    "systemHealth.systemHealth": "System Health",
    "systemHealth.systemMemory": "System Memory",
    "userDetail.save": "Save",
    "userImpersonate.id": "ID",
    "userImpersonate.joined": "Joined",
    "userImpersonate.lastLogin": "Last Login",
    "userImpersonate.noBookings": "No bookings",
    "userImpersonate.noWeddings": "No weddings",
    "userImpersonate.partner": "Partner",
    "userImpersonate.price": "Price",
    "userImpersonate.readonlyView": "Read-Only View",
    "userImpersonate.status": "Status",
    "userImpersonate.userId": "User ID",
    "userImpersonate.weddingDate": "Wedding Date",
    "users.actions": "Actions",
    "users.delete": "Delete",
    "users.edit": "Edit",
    "users.email": "Email",
    "users.joined": "Joined",
    "users.name": "Name",
    "users.noUsersFound": "No users found",
    "users.resetPassword": "Reset Password",
    "users.role": "Role",
    "users.searchByNameOr": "Search by name or email...",
    "users.status": "Status",
    "users.thisActionCannotBe": "This action cannot be undone.",
    "vendors.actions": "Actions",
    "vendors.business": "Business",
    "vendors.category": "Category",
    "vendors.city": "City",
    "vendors.delete": "Delete",
    "vendors.featured": "Featured",
    "vendors.noVendorsFound": "No vendors found",
    "vendors.priceFrom": "Price From",
    "vendors.rating": "Rating",
    "vendors.searchByBusinessName": "Search by business name or city...",
    "vendors.status": "Status",
    "vendors.thisWillRemoveThe": "This will remove the vendor listing.",
    "vendors.verified": "Verified",
    "venues.actions": "Actions",
    "venues.capacity": "Capacity",
    "venues.city": "City",
    "venues.delete": "Delete",
    "venues.noVenuesFound": "No venues found",
    "venues.priceplate": "Price/Plate",
    "venues.rating": "Rating",
    "venues.searchByNameOr": "Search by name or city...",
    "venues.type": "Type",
    "venues.venueName": "Venue Name"
  },
  cityWeddingPage: {
    averageWeddingBudget: "Average wedding budget:",
    avgBudget: "Avg Budget",
    bestTimeToGet: "Best time to get married:",
    browseAllVendors: "Browse All Vendors",
    createFreeAccount: "Create Free Account",
    getStartedFree: "Get Started Free",
    join25000CouplesWho: "Join 25,000+ couples who trust VowsEra for their big day",
    peakSeason: "Peak Season",
    planYourWeddingIn: "Plan Your Wedding in Other Cities",
    popularVenueTypes: "Popular venue types:",
    popularWeddingTraditions: "Popular wedding traditions:",
    state: "State"
  },
  coord: {
    "calendar.noUpcomingEvents": "No upcoming events",
    "dashboard.checklist": "Checklist",
    "dashboard.countdown": "Countdown",
    "dashboard.nextActions": "NEXT ACTIONS",
    "dashboard.noWeddingsAssignedYet": "No weddings assigned yet.",
    "dashboard.theAdminOrCouples": "The admin or couples will assign weddings to your account.",
    "dashboard.weddingDate": "Wedding Date",
    "multiWeddingDashboard.city": "City",
    "multiWeddingDashboard.couple": "Couple",
    "multiWeddingDashboard.date": "Date",
    "multiWeddingDashboard.guests": "Guests",
    "multiWeddingDashboard.multiweddingDashboard": "Multi-Wedding Dashboard",
    "multiWeddingDashboard.noCoordinatorAssignmentsFound": "No coordinator assignments found",
    "multiWeddingDashboard.status": "Status",
    "vendorNetwork.noVendorsFound": "No vendors found",
    "vendorNetwork.searchVendors": "Search vendors...",
    "weddingView.actual": "Actual",
    "weddingView.amount": "Amount",
    "weddingView.category": "Category",
    "weddingView.checklistProgress": "Checklist Progress",
    "weddingView.date": "Date",
    "weddingView.dietary": "Dietary",
    "weddingView.dueDate": "Due Date",
    "weddingView.email": "Email",
    "weddingView.estimated": "Estimated",
    "weddingView.item": "Item",
    "weddingView.name": "Name",
    "weddingView.noBookings": "No bookings",
    "weddingView.noGuests": "No guests",
    "weddingView.package": "Package",
    "weddingView.rsvp": "RSVP",
    "weddingView.status": "Status",
    "weddingView.task": "Task",
    "weddingView.vendor": "Vendor",
    "weddingView.weddingNotFoundOr": "Wedding not found or access denied.",
    "whiteLabelConfig.availablePlans": "Available Plans",
    "whiteLabelConfig.brandSettings": "Brand Settings",
    "whiteLabelConfig.customizeVowseraWithYour": "Customize VowsEra with your own brand for your clients",
    "whiteLabelConfig.livePreview": "Live Preview",
    "whiteLabelConfig.primary": "Primary",
    "whiteLabelConfig.secondary": "Secondary",
    "whiteLabelConfig.whitelabelBranding": "White-Label Branding",
    "whiteLabelConfig.yourCompanyName": "Your Company Name"
  },
  dash: {
    "accommodationManager.accommodations": "Accommodations",
    "accommodationManager.manageHotelBlocksShuttles": "Manage hotel blocks & shuttles",
    "accommodationManager.shuttleDetails": "Shuttle details",
    "affiliateDashboard.affiliate": "Affiliate",
    "affiliateDashboard.affiliateDashboard": "Affiliate Dashboard",
    "affiliateDashboard.affiliateProgram": "Affiliate Program",
    "affiliateDashboard.credit": "Credit",
    "affiliateDashboard.date": "Date",
    "affiliateDashboard.earnings": "Earnings",
    "affiliateDashboard.joinOurAffiliateProgram": "Join Our Affiliate Program",
    "affiliateDashboard.leaderboardIsEmpty": "Leaderboard is empty",
    "affiliateDashboard.noReferralsYetShare": "No referrals yet. Share your code to start earning!",
    "affiliateDashboard.referrals": "Referrals",
    "affiliateDashboard.referredUser": "Referred User",
    "affiliateDashboard.status": "Status",
    "affiliateDashboard.yourReferralCode": "Your Referral Code",
    "aiConcierge.aiResponsesAreSuggestions": "AI responses are suggestions — always verify vendor details and pricing directly.",
    "aiConcierge.aiWeddingConcierge": "AI Wedding Concierge",
    "aiConcierge.askMeAnythingAbout": "Ask me anything about your wedding...",
    "aiConcierge.delete": "Delete",
    "aiConcierge.newChat": "New chat",
    "aiConcierge.noConversationsYet": "No conversations yet",
    "aiContentWriter.aiContentWriterU2014": "AI Content Writer \u2014 VowsEra",
    "aiContentWriter.generateBeautifulPersonalizedC": "Generate beautiful, personalized content for every section of your wedding website",
    "aiContentWriter.howItWorks": "How it works",
    "aiContentWriter.theMoreYouShare": "The more you share, the more personalized and unique the AI-generated content will be. All fields are optional — the AI will work with whatever you provide.",
    "aiEmailDrafter.aiEmailDrafterVowsera": "AI Email Drafter — VowsEra",
    "aiEmailDrafter.generatePersonalizedWeddingMes": "Generate personalized wedding messages in seconds — vendor inquiries, RSVP reminders, thank-you notes, and more.",
    "aiEmailDrafter.generatedDraft": "Generated Draft",
    "aiEmailDrafter.subject": "Subject:",
    "aiVendorMatcher.addYourWeddingDetails": "Add your wedding details (city, budget, date) to get personalized recommendations.",
    "aiVendorMatcher.aiVendorMatcher": "AI Vendor Matcher",
    "aiVendorMatcher.aiVendorMatcherVowsera": "AI Vendor Matcher — VowsEra",
    "aiVendorMatcher.bookedOnYourDate": "Booked on your date",
    "aiVendorMatcher.noVendorMatchesFound": "No vendor matches found",
    "aiVendorMatcher.yourPerfectVendorMatches": "Your Perfect Vendor Matches ✨",
    "analytics.allergies": "Allergies",
    "analytics.analyticsU2014Vowsera": "Analytics \u2014 VowsEra",
    "analytics.budgetByCategory": "Budget by Category",
    "analytics.estimated": "Estimated",
    "analytics.expenseSplitDetails": "Expense Split Details",
    "analytics.guest": "Guest",
    "analytics.guestGroups": "Guest Groups",
    "analytics.items": "Items",
    "analytics.mealPreferences": "Meal Preferences",
    "analytics.noAllergiesReportedGuests": "No allergies reported. Guests can add allergies when RSVPing.",
    "analytics.noDataYetStart": "No data yet. Start planning to see analytics!",
    "analytics.noGuestGroupsDefined": "No guest groups defined.",
    "analytics.noMealPreferencesCollected": "No meal preferences collected yet. Guests can set their preference when RSVPing.",
    "analytics.noPaymentsRecordedYet": "No payments recorded yet.",
    "analytics.paid": "Paid",
    "analytics.payer": "Payer",
    "analytics.paymentTimeline": "Payment Timeline",
    "analytics.preference": "Preference",
    "analytics.realtimeInsightsIntoYour": "Real-time insights into your wedding planning progress",
    "analytics.remaining": "Remaining",
    "analytics.rsvpBreakdown": "RSVP Breakdown",
    "analytics.total": "Total",
    "analytics.whosPayingWhat": "Who's Paying What",
    "attirePlanner.attirePlanner": "Attire Planner",
    "billingPage.amount": "Amount",
    "billingPage.apply": "Apply",
    "billingPage.billingPlan": "Billing & Plan",
    "billingPage.commissionRate": "Commission Rate",
    "billingPage.currentPlan": "Current Plan",
    "billingPage.date": "Date",
    "billingPage.description": "Description",
    "billingPage.downgrade": "Downgrade",
    "billingPage.downgradeToFree": "Downgrade to Free",
    "billingPage.earn25CreditFor": "Earn $25 credit for every friend who signs up and books a vendor. Share your unique link and grow your rewards.",
    "billingPage.enterPromoCode": "Enter promo code",
    "billingPage.joinOurReferralProgram": "Join Our Referral Program",
    "billingPage.manageYourPlanPayments": "Manage your plan, payments, and referral program",
    "billingPage.noCreditCardRequired": "No credit card required. Cancel anytime.",
    "billingPage.noPaymentsYetYour": "No payments yet. Your payment history will appear here.",
    "billingPage.pendingPayout": "Pending Payout",
    "billingPage.status": "Status",
    "billingPage.totalEarned": "Total Earned",
    "billingPage.totalReferrals": "Total Referrals",
    "billingPage.tryGoldFreeFor": "Try Gold Free for 7 Days",
    "budgetOptimizer.addBudgetItemsTo": "Add budget items to see regional comparisons.",
    "budgetOptimizer.budget": "Budget",
    "budgetOptimizer.budgetUsage": "Budget Usage",
    "budgetOptimizer.estimatedSpend": "Estimated Spend",
    "budgetOptimizer.ideal": "Ideal:",
    "budgetOptimizer.luxury": "Luxury",
    "budgetOptimizer.moderate": "Moderate",
    "budgetOptimizer.noMajorOptimizationOpportuniti": "No major optimization opportunities found. You're spending wisely.",
    "budgetOptimizer.paidSoFar": "Paid So Far",
    "budgetOptimizer.potentialSavings": "Potential Savings",
    "budgetOptimizer.premium": "Premium",
    "budgetOptimizer.smartBudgetOptimizerU2014": "Smart Budget Optimizer \u2014 VowsEra",
    "budgetOptimizer.totalBudget": "Total Budget",
    "budgetOptimizer.whatToDo": "What to do:",
    "budgetOptimizer.your": "Your:",
    "budgetOptimizer.yourAllocationVsRecommended": "Your Allocation vs Recommended",
    "budgetOptimizer.yourBudgetLooksGreat": "Your budget looks great!",
    "ceremonyTemplates.chooseATemplateThat": "Choose a template that matches your wedding traditions. It will auto-create checklists, budget items, and ceremony guides.",
    "ceremonyTemplates.viewCeremoniesApply": "View Ceremonies & Apply",
    "conflictDetector.aiConflictDetectorVowsera": "AI Conflict Detector — VowsEra",
    "conflictDetector.allClear": "All Clear!",
    "conflictDetector.autodetectsIssuesThatCould": "Auto-detects issues that could derail your wedding plans",
    "conflictDetector.critical": "Critical",
    "conflictDetector.info": "Info",
    "conflictDetector.noConflictsDetectedYour": "No conflicts detected. Your wedding planning is on track.",
    "conflictDetector.runningConflictDetectionAcross": "Running conflict detection across your wedding data...",
    "conflictDetector.totalIssues": "Total Issues",
    "conflictDetector.warnings": "Warnings",
    "conflictDetector.weddingHealthScore": "Wedding Health Score",
    "currencyConverter.amount": "Amount",
    "currencyConverter.convert": "Convert",
    "currencyConverter.convertPricesForYour": "Convert prices for your destination wedding or international guests",
    "currencyConverter.currencyConverter": "Currency Converter",
    "currencyConverter.exchangeRates": "Exchange Rates",
    "currencyConverter.from": "From",
    "currencyConverter.noExchangeRatesAvailable": "No exchange rates available. Seed currency data first.",
    "currencyConverter.rate": "Rate",
    "currencyConverter.to": "To",
    "dashboardHome.dashboardU2014Vowsera": "Dashboard \u2014 VowsEra",
    "dashboardHome.noWeddingDataFound": "No wedding data found.",
    "dashboardHome.youreOnTopOf": "You're on top of everything! Check back later for new suggestions.",
    "dataExport.dataPrivacy": "Data & Privacy",
    "dataExport.downloadAllYourPersonal": "Download all your personal data including wedding details, guest lists, bookings, and payments as a JSON file.",
    "dataExport.thisWillAnonymizeAll": "This will anonymize all your personal data. Booking history will be preserved for vendor records but your identity will be removed. This action cannot be undone.",
    "dietaryManager.count": "Count",
    "dietaryManager.dietType": "Diet Type",
    "dietaryManager.guestDietaryManager": "Guest Dietary Manager",
    "dietaryManager.guests": "Guests",
    "dietaryManager.noDietaryProfilesYet": "No dietary profiles yet. Add profiles for guests with dietary requirements.",
    "dietaryManager.saveProfile": "Save Profile",
    "documentVault.description": "Description",
    "documentVault.documentTitle": "Document Title*",
    "documentVault.documentVault": "Document Vault",
    "documentVault.fileName": "File Name",
    "documentVault.fileUrl": "File URL*",
    "documentVault.securelyStoreContractsInvoices": "Securely store contracts, invoices & important documents",
    "documentVault.upload": "Upload",
    "familyChat.chatRooms": "Chat Rooms",
    "familyChat.create": "Create",
    "familyChat.familyChat": "Family Chat",
    "familyChat.noRoomsYet": "No rooms yet",
    "familyChat.roomName": "Room name",
    "familyChat.typeAMessage": "Type a message...",
    "familyPortal.addMember": "Add Member",
    "familyPortal.addTask": "Add Task",
    "familyPortal.budgetContribution": "Budget Contribution ($)",
    "familyPortal.ceremonyRoleEgBest": "Ceremony Role (e.g. Best Man)",
    "familyPortal.description": "Description",
    "familyPortal.email": "Email",
    "familyPortal.familyPortal": "Family Portal",
    "familyPortal.firstName": "First Name",
    "familyPortal.lastName": "Last Name",
    "familyPortal.manageFamilyRolesTasks": "Manage family roles, tasks & contributions",
    "familyPortal.phone": "Phone",
    "familyPortal.taskTitle": "Task Title",
    "gallerySubmission.aBriefSummaryThat": "A brief summary that appears on the gallery listing cards...",
    "gallerySubmission.add": "Add",
    "gallerySubmission.addATagEg": "Add a tag (e.g. outdoor, sangeet)",
    "gallerySubmission.addColor": "Add Color",
    "gallerySubmission.basicInformation": "Basic Information",
    "gallerySubmission.captionOptional": "Caption (optional)",
    "gallerySubmission.categoryEgPhotographer": "Category (e.g. Photographer)",
    "gallerySubmission.colorPalette": "Color Palette",
    "gallerySubmission.egEmilyPriyaRahul": "E.g. Emily Priya & Rahul — A Garden Wedding in Jaipur Ryan — A Garden Wedding in Napa Valley",
    "gallerySubmission.feedbackFromAdmin": "Feedback from admin:",
    "gallerySubmission.photoUrlHttps": "Photo URL (https://...)",
    "gallerySubmission.profileUrlOptional": "Profile URL (optional)",
    "gallerySubmission.shareYourLoveStory": "Share your love story with thousands of couples for inspiration.",
    "gallerySubmission.submitYourWedding": "Submit Your Wedding",
    "gallerySubmission.submitYourWeddingTo": "Submit Your Wedding to the Gallery",
    "gallerySubmission.tags": "Tags",
    "gallerySubmission.tellUsAboutYour": "Tell us about your wedding day — how you met, the planning journey, your favorite moments...",
    "gallerySubmission.vendorCredits": "Vendor Credits",
    "gallerySubmission.vendorName": "Vendor Name",
    "gallerySubmission.weddingDetails": "Wedding Details",
    "giftRegistry.addItemsYoudLove": "Add items you'd love to receive as gifts.",
    "giftRegistry.amount": "Amount",
    "giftRegistry.amountgift": "Amount/Gift",
    "giftRegistry.cashFundsGiftWishlist": "Cash funds, gift wishlist, and track every gift with thank-you lists",
    "giftRegistry.category": "Category",
    "giftRegistry.contact": "Contact",
    "giftRegistry.createYourFirstCash": "Create your first cash fund — Honeymoon, New Home, Date Night!",
    "giftRegistry.event": "Event",
    "giftRegistry.eventWeddingReception": "Event (Wedding, Reception...)",
    "giftRegistry.from": "From",
    "giftRegistry.gift": "Gift",
    "giftRegistry.giftDescription": "Gift description",
    "giftRegistry.giftRegistryCashGift": "Gift Registry & Cash Gift Tracker \u2014 VowsEra",
    "giftRegistry.guestName": "Guest name",
    "giftRegistry.instructionsForGuests": "Instructions for guests",
    "giftRegistry.name": "Name",
    "giftRegistry.noGiftsRecordedYet": "No gifts recorded yet.",
    "giftRegistry.notesOptional": "Notes (optional)",
    "giftRegistry.price": "Price",
    "giftRegistry.productUrlOptional": "Product URL (optional)",
    "giftRegistry.relation": "Relation",
    "giftRegistry.relationUncleFriend": "Relation (Uncle, Friend...)",
    "giftRegistry.shareYourGiftRegistry": "Share your gift registry with guests so they can see your wishlist and contribute to cash funds.",
    "giftRegistry.status": "Status",
    "giftRegistry.type": "Type",
    "guestOptimizer.aiGuestOptimizer": "AI Guest Optimizer",
    "guestOptimizer.analyzeYourGuestList": "Analyze your guest list against budget and venue capacity",
    "guestOptimizer.clickRunAnalysisTo": "Click \"Run Analysis\" to get AI-powered insights on your guest list, budget allocation, and seating capacity.",
    "guestOptimizer.lookingGood": "Looking good!",
    "guestOptimizer.noIssuesDetectedWith": "No issues detected with your guest list.",
    "guestOptimizer.readyToOptimize": "Ready to optimize",
    "guestOptimizer.rsvpProgress": "RSVP Progress",
    "honeymoonPlanner.honeymoonPlanner": "Honeymoon Planner",
    "honeymoonPlanner.oneItemPerLine": "One item per line...",
    "honeymoonPlanner.planYourPostweddingGetaway": "Plan your post-wedding getaway",
    "honeymoonPlanner.snorkelingSpaDay": "Snorkeling, Spa day...",
    "invitationBuilder.colors": "Colors",
    "invitationBuilder.content": "Content",
    "invitationBuilder.designStunningDigitalInvitatio": "Design stunning digital invitations and share them instantly via WhatsApp or Email",
    "invitationBuilder.fonts": "Fonts",
    "invitationBuilder.guestName": "Guest name",
    "invitationBuilder.invitationBuilderU2014Vowsera": "Invitation Builder \u2014 VowsEra",
    "invitationBuilder.livePreview": "LIVE PREVIEW",
    "invitationBuilder.noTemplatesFoundFor": "No templates found for this filter.",
    "liveEventFeed.imageUrl": "Image URL",
    "liveEventFeed.liveEventFeed": "Live Event Feed",
    "liveEventFeed.noPostsYet": "No posts yet",
    "liveEventFeed.optionsCommaSeparated": "Options (comma separated)",
    "liveEventFeed.pollQuestion": "Poll question",
    "liveEventFeed.post": "Post",
    "liveEventFeed.realtimeUpdatesPhotosMessages": "Real-time updates, photos & messages from your wedding",
    "liveEventFeed.startSharingMomentsFrom": "Start sharing moments from your wedding!",
    "liveEventFeed.whatsHappening": "What's happening?",
    "moodBoard.collectInspirationColorsDecor": "Collect inspiration — colors, decor, dress ideas & more",
    "moodBoard.imageUrl": "Image URL",
    "moodBoard.moodBoard": "Mood Board",
    "moodBoard.notes": "Notes",
    "moodBoard.pickAColor": "Pick a color",
    "moodBoard.save": "Save",
    "moodBoard.sourceUrl": "Source URL",
    "moodBoard.title": "Title",
    "multiEventManager.manageAllYourWedding": "Manage all your wedding ceremonies — each with its own guests, venue, dress code & timeline",
    "multiEventManager.noEventsYet": "No Events Yet",
    "multiEventManager.prepopulateEventsBasedOn": "Pre-populate events based on your wedding tradition. You can customize afterward.",
    "multiEventManager.startByUsingA": "Start by using a cultural template or adding events manually",
    "multiEventManager.venueNameAddress": "Venue name & address",
    "multiEventManager.weddingEvents": "Wedding Events",
    "notificationCenter.availableCredits": "Available credits",
    "notificationCenter.browserPushNotifications": "Browser push notifications",
    "notificationCenter.changesSavedAutomatically": "Changes saved automatically.",
    "notificationCenter.notifications": "Notifications",
    "notificationCenter.pushNotificationsAreNot": "Push notifications are not supported in this browser.",
    "notificationCenter.reviewsWritten": "Reviews written",
    "notificationCenter.totalEarned": "Total earned",
    "notificationCenter.writeReviews": "Write Reviews",
    "notificationRules.budgetAlerts": "Budget alerts",
    "notificationRules.contextawareRemindersThatKeep": "Context-aware reminders that keep your planning on track",
    "notificationRules.countdownMilestones": "Countdown milestones",
    "notificationRules.noNotificationsYetClick": "No notifications yet. Click \"Run Check Now\" to evaluate your wedding.",
    "notificationRules.ourRulesEngineAutomatically": "Our rules engine automatically evaluates your wedding data daily and sends context-aware notifications when it detects something that needs your attention.",
    "notificationRules.rsvpReminders": "RSVP reminders",
    "notificationRules.smartNotificationsVowsera": "Smart Notifications — VowsEra",
    "notificationRules.vendorAlerts": "Vendor alerts",
    "notifications.notificationsU2014Vowsera": "Notifications \u2014 VowsEra",
    "notifications.stayUpdatedOnYour": "Stay updated on your wedding planning progress",
    "notifications.youreAllCaughtUp": "You're all caught up!",
    "onboardingWizard.budgetGuestCount": "Budget & guest count",
    "onboardingWizard.dontWorryIfYou": "Don't worry if you haven't decided yet \u2014 you can update later",
    "onboardingWizard.helpsUsOptimizeYour": "Helps us optimize your planning and suggest the right vendors",
    "onboardingWizard.heresAQuickSummary": "Here's a quick summary. You can always change these later.",
    "onboardingWizard.orEnterExactAmount": "Or enter exact amount",
    "onboardingWizard.setUpYourWedding": "Set Up Your Wedding \u2014 VowsEra",
    "onboardingWizard.tellUsAboutThe": "Tell us about the happy couple",
    "onboardingWizard.thisHelpsUsRecommend": "This helps us recommend the right templates, vendors, and traditions",
    "onboardingWizard.vowseraWillAutocreateYour": "VowsEra will auto-create your wedding website, recommend ceremony templates for your culture, and set up your budget allocations.",
    "onboardingWizard.weMetAtA": "We met at a coffee shop in 2020...",
    "onboardingWizard.whatsYourStyle": "What's your style?",
    "onboardingWizard.whenAndWhere": "When and where?",
    "onboardingWizard.whosGettingMarried": "Who's getting married?",
    "photoTags.addTag": "Add Tag",
    "photoTags.noTagsYetUpload": "No tags yet. Upload photos and add tags to organize them!",
    "photoTags.photoTags": "Photo Tags",
    "photoTags.photoUuid": "Photo UUID",
    "photoTags.tagCloud": "Tag Cloud",
    "photoWall.noPendingUploadsTo": "No pending uploads to moderate.",
    "photoWall.noPhotosYet": "No photos yet",
    "photoWall.photoWallU2014Vowsera": "Photo Wall \u2014 VowsEra",
    "photoWall.shareThisLinkWith": "Share this link with guests so they can view and upload photos from your wedding.",
    "photoWall.sharedGalleryForYour": "Shared gallery for your wedding memories — guests can upload and react",
    "photoWall.uploadPhotosOrShare": "Upload photos or share the link with guests so they can add theirs!",
    "planningBoards.collaborateWithYourPartner": "Collaborate with your partner & family on wedding ideas",
    "planningBoards.createYourFirstBoard": "Create your first board to start pinning ideas, comparing options, and making decisions together.",
    "planningBoards.noBoardsYet": "No boards yet",
    "planningBoards.noPinsYet": "No pins yet",
    "postWedding.action": "Action",
    "postWedding.addALiveCountdown": "Add a live countdown to your blog or personal website.",
    "postWedding.amount": "Amount",
    "postWedding.daysToGo": "DAYS TO GO",
    "postWedding.event": "Event",
    "postWedding.generatingPersonalizedMessage": "Generating personalized message...",
    "postWedding.gift": "Gift",
    "postWedding.giftFrom": "Gift From",
    "postWedding.marriedFor": "MARRIED FOR",
    "postWedding.nextAnniversary": "NEXT ANNIVERSARY",
    "postWedding.noGiftsRecordedYet": "No gifts recorded yet. Record gifts in the Gift Registry to generate thank-you cards.",
    "postWedding.postweddingU2014Vowsera": "Post-Wedding \u2014 VowsEra",
    "postWedding.poweredByVowsera": "Powered by VowsEra",
    "postWedding.preview": "Preview",
    "postWedding.setYourWeddingDate": "Set your wedding date to see a preview.",
    "postWedding.status": "Status",
    "postWedding.thankyouCardsNameChange": "Thank-you cards, name change checklist, anniversary tracker, and more",
    "postWedding.weddingOf": "WEDDING OF",
    "qrInvites.actions": "Actions",
    "qrInvites.generateQrCodesAnd": "Generate QR codes and send invitations via WhatsApp or Email",
    "qrInvites.guest": "Guest",
    "qrInvites.noQrInvitesYet": "No QR invites yet. Click \"Generate for All Guests\" to start.",
    "qrInvites.phone": "Phone",
    "qrInvites.scanned": "Scanned",
    "qrInvites.sendWhatsapp": "Send WhatsApp",
    "qrInvites.status": "Status",
    "qrInvites.viewQr": "View QR",
    "rehearsalPlanner.listNamesAndRoles": "List names and roles (one per line)",
    "rehearsalPlanner.planYourRehearsalAnd": "Plan your rehearsal and rehearsal dinner",
    "rehearsalPlanner.rehearsalPlanner": "Rehearsal Planner",
    "rehearsalPlanner.sameAsCeremonyVenue": "Same as ceremony venue?",
    "rsvpAnalytics.attendanceBySide": "Attendance by Side",
    "rsvpAnalytics.dietaryRestrictionsOverview": "Dietary Restrictions Overview",
    "rsvpAnalytics.editInGuestList": "Edit in Guest List",
    "rsvpAnalytics.followupList": "Follow-Up List",
    "rsvpAnalytics.guestBreakdownBySidegroup": "Guest breakdown by side/group — assign guests in the Guest List for accurate grouping.",
    "rsvpAnalytics.guestDistributionByGroup": "Guest Distribution by Group",
    "rsvpAnalytics.mealPreferences": "Meal Preferences",
    "rsvpAnalytics.noContact": "No contact",
    "rsvpAnalytics.noGroupDataYet": "No group data yet — assign guests to sides in the Guest List.",
    "rsvpAnalytics.responseBreakdown": "Response Breakdown",
    "rsvpAnalytics.responsesOverTime": "Responses Over Time",
    "rsvpAnalytics.rsvpAnalytics": "RSVP Analytics",
    "rsvpAnalytics.rsvpAnalyticsVowsera": "RSVP Analytics — VowsEra",
    "rsvpAnalytics.searchNameEmailGroup": "Search name, email, group…",
    "rsvpAnalytics.tipUseTheGuest": "Tip: Use the Guest List to bulk-update RSVP status or export to CSV.",
    "rsvpAnalytics.weddingAnalytics": "Wedding Analytics",
    "seatingChart.addFromUnassigned": "ADD FROM UNASSIGNED",
    "seatingChart.allGuestsAreSeated": "All guests are seated!",
    "seatingChart.capacity": "CAPACITY",
    "seatingChart.category": "CATEGORY",
    "seatingChart.colorFromCategoryOverride": "Color from category · Override:",
    "seatingChart.danceFloor": "DANCE FLOOR",
    "seatingChart.displayLabel": "DISPLAY LABEL",
    "seatingChart.dragOntoCanvasOr": "DRAG ONTO CANVAS OR USE DROPDOWN",
    "seatingChart.guests": "Guests",
    "seatingChart.noGuestsSeatedYet": "No guests seated yet.",
    "seatingChart.noTablesYet": "No tables yet",
    "seatingChart.seatedGuests": "SEATED GUESTS",
    "seatingChart.seatingChartVowsera": "Seating Chart — VowsEra",
    "seatingChart.seats": "Seats",
    "seatingChart.shape": "SHAPE",
    "seatingChart.table": "Table",
    "seatingChart.tableName": "TABLE NAME *",
    "seatingChart.venueFillRate": "Venue Fill Rate",
    "sideManagement.budget": "Budget",
    "sideManagement.contributions": "Contributions",
    "sideManagement.familyContributions": "Family Contributions",
    "sideManagement.familyMembers": "Family Members",
    "sideManagement.guests": "Guests",
    "sideManagement.sideManagement": "Side Management",
    "sideManagement.totalBudget": "Total Budget",
    "sideManagement.totalGuests": "Total Guests",
    "speechCoordinator.bestManMaidOf": "Best Man, Maid of Honor...",
    "speechCoordinator.pasteSpeechDraftHere": "Paste speech draft here...",
    "speechCoordinator.speechToastCoordinator": "Speech & Toast Coordinator",
    "speechCoordinator.totalSpeechBlock": "Total Speech Block",
    "styleRecommender.aiStyleRecommender": "AI Style Recommender",
    "styleRecommender.fillInYourPreferences": "Fill in your preferences and click \"Get Recommendations\" to see AI-powered suggestions for your wedding!",
    "styleRecommender.readyForYourStyle": "Ready for your style?",
    "styleRecommender.tellUsAboutYour": "Tell us about your style preferences and we'll recommend themes, colors, and vendors",
    "styleRecommender.yourStyleProfile": "Your Style Profile",
    "timelineExport.noTimelineItemsCreate": "No timeline items. Create your day-of timeline first.",
    "timelineExport.printreadyScheduleForVendors": "Print-ready schedule for vendors, coordinators, and family",
    "timelineExport.timelineExportU2014Vowsera": "Timeline Export \u2014 VowsEra",
    "timelineExport.viewFor": "View for:",
    "vendorAnalytics.current": "Current",
    "vendorAnalytics.noInquiryDataFor": "No inquiry data for this period",
    "vendorAnalytics.noSeasonalDataYet": "No seasonal data yet",
    "vendorAnalytics.offpeak": "Off-peak",
    "vendorAnalytics.peak": "Peak",
    "vendorAnalytics.peakMonths": "Peak Months:",
    "vendorAnalytics.yourPriceTier": "Your Price Tier",
    "vendorCalendar.anyNotesForThe": "Any notes for the vendor",
    "vendorCalendar.checkRealtimeAvailabilityHold": "Check real-time availability, hold dates, and book vendors instantly",
    "vendorCalendar.checkVendorAvailability": "Check Vendor Availability",
    "vendorCalendar.enterAVendorId": "Enter a vendor ID or select from your shortlisted vendors to check their calendar.",
    "vendorCalendar.orClickTheCalendar": "Or click the calendar icon on any of your holds above.",
    "vendorCalendar.vendorAvailabilityU2014Vowsera": "Vendor Availability \u2014 VowsEra",
    "vendorCalendar.vendorId": "Vendor ID",
    "vendorCheckins.actions": "Actions",
    "vendorCheckins.createGenerateQr": "Create & Generate QR",
    "vendorCheckins.expected": "Expected",
    "vendorCheckins.in": "In",
    "vendorCheckins.noEntriesMatchingFilter": "No entries matching filter.",
    "vendorCheckins.out": "Out",
    "vendorCheckins.qr": "QR",
    "vendorCheckins.status": "Status",
    "vendorCheckins.vendor": "Vendor",
    "vendorCheckins.vendorCheckin": "Vendor Check-In",
    "vendorCheckins.vendorUuid": "Vendor UUID",
    "vendorCompare.actions": "Actions",
    "vendorCompare.available": "Available",
    "vendorCompare.browseVendorsAndClick": "Browse vendors and click the bookmark icon to add them here.",
    "vendorCompare.latestReview": "Latest Review",
    "vendorCompare.noQuoteRequestsYet": "No quote requests yet",
    "vendorCompare.noVendorsShortlistedYet": "No vendors shortlisted yet",
    "vendorCompare.opensAsHtmlUse": "Opens as HTML — use Print → Save as PDF",
    "vendorCompare.packages": "Packages",
    "vendorCompare.portfolio": "Portfolio",
    "vendorCompare.priceRange": "Price Range",
    "vendorCompare.quotedAmount": "Quoted Amount",
    "vendorCompare.rating": "Rating",
    "vendorCompare.requested": "Requested",
    "vendorCompare.service": "Service",
    "vendorCompare.services": "Services",
    "vendorCompare.shortlistVendorsCompareSidebys": "Shortlist vendors, compare side-by-side, and find the best value",
    "vendorCompare.startingPrice": "Starting Price",
    "vendorCompare.status": "Status",
    "vendorCompare.vendor": "Vendor",
    "vendorSubscription.cancel": "Cancel",
    "vendorSubscription.currentPlan": "Current Plan",
    "vendorSubscription.downgrade": "Downgrade",
    "vendorSubscription.upgradeYourVendorProfile": "Upgrade your vendor profile to reach more couples and grow your business",
    "vendorVerification.getVerifiedToBuild": "Get verified to build trust with couples and rank higher in search results",
    "vendorVerification.getYourVerifiedBadge": "Get Your Verified Badge",
    "vendorVerification.ourTeamIsReviewing": "Our team is reviewing your documents. This usually takes 2-3 business days.",
    "vendorVerification.verificationUnderReview": "Verification Under Review",
    "vendorVerification.verifiedBusiness": "Verified Business",
    "vendorVerification.verifiedVendorsGet3x": "Verified vendors get 3x more inquiries and rank higher in search. Complete the steps below.",
    "weatherForecast.avgHigh": "Avg High",
    "weatherForecast.avgLow": "Avg Low",
    "weatherForecast.noWeatherDataAvailable": "No weather data available",
    "weatherForecast.rainChance": "Rain Chance",
    "weatherForecast.riskLevel": "Risk Level",
    "weatherForecast.weatherForecastVowsera": "Weather Forecast — VowsEra",
    "weatherForecast.weddingWeather": "Wedding Weather",
    "weddingCountdown.addYourWeddingDate": "Add your wedding date to start the countdown.",
    "weddingCountdown.everythingYouvePlannedHas": "Everything you've planned has led to this moment. ✨",
    "weddingCountdown.planningAtAGlance": "Planning at a Glance",
    "weddingCountdown.planningMilestones": "Planning Milestones",
    "weddingCountdown.smartReminders": "Smart Reminders",
    "weddingCountdown.todayIsTheDay": "Today is the Day!",
    "weddingCountdown.weddingCountdownVowsera": "Wedding Countdown — VowsEra",
    "weddingProgressTracker.complete": "Complete",
    "weddingProgressTracker.milestoneUnlocked": "Milestone Unlocked!",
    "weddingProgressTracker.planningAchievements": "Planning Achievements",
    "weddingProgressTracker.planningMilestones": "Planning Milestones",
    "weddingProgressTracker.weddingPlanningProgress": "Wedding Planning Progress",
    "weddingProgressTracker.weddingProgressVowsera": "Wedding Progress — VowsEra",
    "weddingTimeline.autogenerateFromEvents": "Auto-Generate from Events",
    "weddingTimeline.clickAutogenerateToCreate": "Click \"Auto-Generate\" to create a timeline from your wedding events, or add items manually.",
    "weddingTimeline.createShareableLinksFor": "Create shareable links for family, vendors, or guests to view the live timeline on their phones.",
    "weddingTimeline.location": "Location",
    "weddingTimeline.minutebyminuteScheduleWithLive": "Minute-by-minute schedule with live tracking for your wedding day",
    "weddingTimeline.noShareLinksYet": "No share links yet. Create one above.",
    "weddingTimeline.noTimelineItemsYet": "No timeline items yet",
    "weddingTimeline.notes": "Notes...",
    "weddingTimeline.weddingDayTimelineU2014": "Wedding Day Timeline \u2014 VowsEra",
    "weddingWebsite.websiteBuilder": "Website Builder",
    "weddingWebsite.weddingWebsiteBuilder": "Wedding Website Builder"
  },
  gallery: {
    "galleryDetail.budgetRange": "Budget Range",
    "galleryDetail.city": "City",
    "galleryDetail.colorPalette": "Color Palette",
    "galleryDetail.culture": "Culture",
    "galleryDetail.guests": "Guests",
    "galleryDetail.joinThousandsOfCouples": "Join thousands of couples using VowsEra to plan their perfect day.",
    "galleryDetail.planningYourWedding": "Planning your wedding?",
    "galleryDetail.style": "Style",
    "galleryDetail.theirStory": "Their Story",
    "galleryDetail.thisGalleryMayHave": "This gallery may have been removed or is not yet published.",
    "galleryDetail.vendorTeam": "Vendor Team",
    "galleryDetail.venue": "Venue",
    "galleryDetail.weddingDate": "Wedding Date",
    "galleryDetail.weddingDetails": "Wedding Details",
    "galleryDetail.weddingNotFound": "Wedding Not Found",
    "galleryDetail.weddingPhotos": "Wedding Photos"
  },
  guest: {
    "giftRegistry.registryProgress": "Registry Progress",
    "guestPortal.dateTime": "Date & Time",
    "guestPortal.dietaryRestrictions": "Dietary Restrictions",
    "guestPortal.dressCode": "Dress Code",
    "guestPortal.eventTimeline": "Event Timeline",
    "guestPortal.giftRegistry": "Gift Registry",
    "guestPortal.goToVowsera": "Go to VowsEra",
    "guestPortal.invitationNotFound": "Invitation Not Found",
    "guestPortal.loadingYourInvitation": "Loading your invitation...",
    "guestPortal.messageToTheCouple": "Message to the Couple (optional)",
    "guestPortal.plusOnes": "Plus Ones",
    "guestPortal.shareAMessageOr": "Share a message or note...",
    "guestPortal.sharePhotosWith": "Share Photos With",
    "guestPortal.venue": "Venue",
    "guestPortal.willYouBeJoining": "Will You Be Joining Us?",
    "guestPortal.yourPresenceIsThe": "Your presence is the greatest gift! If you'd like to contribute, here are some ideas.",
    "home.noInvitationFound": "No Invitation Found",
    "home.saveTheDate": "Save the Date",
    "home.venue": "Venue",
    "home.weCouldntFindA": "We couldn't find a wedding invitation linked to your email.",
    "home.yourDetails": "Your Details",
    "home.yourRsvp": "Your RSVP",
    "home.youreInvited": "You're Invited",
    "photoAlbum.upload": "Upload",
    "rsvp.additionalGuests": "Additional Guests",
    "rsvp.dietaryPreferences": "Dietary Preferences",
    "rsvp.mealChoice": "Meal Choice",
    "rsvp.messageForTheCouple": "Message for the Couple (optional)",
    "rsvp.noInvitationFoundFor": "No invitation found for your email.",
    "rsvp.numberOfPlusones": "Number of plus-ones",
    "rsvp.rsvp": "RSVP",
    "rsvp.sendYourLoveAnd": "Send your love and wishes...",
    "rsvp.willYouBeAttending": "Will you be attending?",
    "schedule.celebrationTimeline": "Celebration Timeline",
    "schedule.eventSchedule": "Event Schedule",
    "schedule.theEventScheduleWill": "The event schedule will be shared soon.",
    "tableFinder.enterYourNameTo": "Enter your name to find your seating assignment",
    "tableFinder.findYourTable": "Find Your Table",
    "tableFinder.poweredByVowsera": "Powered by VowsEra",
    "travelStay.accommodationAndDirections": "Accommodation and directions",
    "travelStay.byCar": "By Car:",
    "travelStay.byMetro": "By Metro:",
    "travelStay.parking": "Parking:",
    "travelStay.theGrandPalaceBanquets": "The Grand Palace Banquets"
  },
  rsvpPage: {
    anyMessageForThe: "Any message for the couple? (optional)",
    contactInformation: "Contact Information",
    emailAddress: "Email Address",
    enterYourNameExactly: "Enter your name exactly as it appears on your invitation",
    findYourInvitation: "Find Your Invitation",
    firstName: "First Name",
    lastName: "Last Name",
    phoneNumber: "Phone Number",
    whatsappOptIn: "Send me updates on WhatsApp — pickup details and a reminder the day before each function. I can turn this off any time.",
    rsvp: "RSVP",
    rsvpAlreadySubmitted: "RSVP Already Submitted",
    rsvpClosed: "RSVP Closed",
    thankYou: "Thank You!",
    weCantWaitTo: "We can't wait to celebrate with you! 🌴"
  },
  termsOfService: {
    byUsingOurService: "By using our service, you agree to these terms...",
    lastUpdatedJanuary2025: "Last updated: January 2025",
    termsOfService: "Terms of Service"
  },
  venueOwner: {
    "amenities.noVenuesAssigned": "No venues assigned.",
    "availability.add": "Add",
    "availability.noSeasonalPricingSet": "No seasonal pricing set",
    "availability.noVenuesAssigned": "No venues assigned.",
    "bookings.accept": "Accept",
    "bookings.actions": "Actions",
    "bookings.amount": "Amount",
    "bookings.couple": "Couple",
    "bookings.decline": "Decline",
    "bookings.declineThisBooking": "Decline this booking?",
    "bookings.eventDate": "Event Date",
    "bookings.guests": "Guests",
    "bookings.markComplete": "Mark Complete",
    "bookings.noBookingsYet": "No bookings yet",
    "bookings.status": "Status",
    "bookings.venue": "Venue",
    "dashboard.capacity": "Capacity",
    "dashboard.city": "City",
    "dashboard.contactTheAdminTo": "Contact the admin to assign venues to your account.",
    "dashboard.noVenuesAssignedTo": "No venues assigned to your account yet.",
    "dashboard.rating": "Rating",
    "dashboard.status": "Status",
    "dashboard.type": "Type",
    "dashboard.venue": "Venue",
    "floorPlanEditor.chooseAPlanFrom": "Choose a plan from the left, or create a new one to start designing.",
    "floorPlanEditor.clickFurnitureItemsAbove": "Click furniture items above to add them, then drag to position",
    "floorPlanEditor.create": "Create",
    "floorPlanEditor.floorPlanEditor": "Floor Plan Editor",
    "floorPlanEditor.noPlansYet": "No plans yet",
    "floorPlanEditor.plans": "Plans",
    "floorPlanEditor.selectAFloorPlan": "Select a floor plan",
    "photos.addPhoto": "Add Photo",
    "photos.caption": "Caption...",
    "photos.grandEntranceHall": "Grand entrance hall...",
    "photos.moveLeft": "Move left",
    "photos.moveRight": "Move right",
    "photos.noPhotosYetAdd": "No photos yet. Add your first photo to showcase your venue.",
    "photos.noVenuesAssignedTo": "No venues assigned to your account.",
    "profile.contactTheAdminTo": "Contact the admin to assign venues to your account.",
    "profile.describeYourVenue": "Describe your venue...",
    "profile.editYourVenueDetails": "Edit your venue details",
    "profile.noVenuesAssigned": "No Venues Assigned",
    "profile.streetAddress": "Street address...",
    "reviews.writeYourResponse": "Write your response...",
    "reviews.yourReply": "Your Reply",
    "venueInquiries.venueInquiries": "Venue Inquiries"
  }
};